/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useSelector } from "react-redux";
import Highcharts from "highcharts";
import { Dropdown } from "react-bootstrap";
import moment from "moment";
import {
  CONSTANTS,
  DATE_FORMATS,
  GRAPH_TYPES,
  VERTICALS,
  REPORT_TYPES,
  LANGUAGE_CODES,
  GRAPH_TYPE_OPTIONS,
  HTTP_CODES,
  WORD_CLOUD_TYPE,
  SOCIAL_SOURCES,
  REPORT_WISE_SOCIAL_ICONS,
  VERTICAL_NAMES,
  LOGO,
  HOTSTAR_ID,
  LANGUAGE_CODE,
} from "../../../constants/app-constant";
import Loader from "../../Shared/Loader";
import { httpDelete, httpGet, httpPost } from "../../../utility/requestHelper";
import { envConfig, unifiedEnvConfig } from "../../../constants/api-endpoint";
import {
  groupBy,
  formatDate,
  getTrendGraphDateFormat,
  removeSpace,
  getSocialApiDateFormat,
  getConceptUserId,
} from "../../../utility/common-methods";
import { DownloadBlueIcon, FacebookIcon, InstagramIcon, MoreIcon, TwitterIcon, YoutubePlayIcon } from "../../Icons/icons.component";
import { onlyUnique } from "../../../utility/arrayUtils";
import "./charts.sass";
import {
  formatedDataByJournalist,
  formatDataByTonality,
  formatDataByRanking,
  formatDataByCity,
  formatDataByLanguage,
  formatThematicAnalysisEntity,
  formatThematicAnalysisTag,
} from "../../Dashboard/data_formatter";
import {
  getLineGraphFormat,
  getRandomUniqueColor,
} from "../../Dashboard/data_formatter/format-utils";
import { formatDataBySOV } from "../../Dashboard/data_formatter/format-data-by-sov";
import { formatDataByPublication } from "../../Dashboard/data_formatter/fomat-data-by-publication";
import WidgetInlineFilters from "../Filters/WidgetInlineFilters";
import EmbededFeedsList from "../News/EmbededFeedsList";
import VerticalTag from "../../Shared/VerticalTag";
import WidgetSwitch from "./WidgetSwitch";
import { AddWidget } from "../../Dashboard/AddWidget";
import {
  DATA_TYPES,
  SOCIAL_SOURCES_OPTIONS,
  TONALITY_FILTER,
  WIDGET_TYPES,
} from "../../../constants/static-filter";
import { ConfirmModal } from "../../Shared/Modal";
import {
  formatDataByTonalitySocial,
  formatSovRankingSocial,
  formatCitySpecificData,
  formatSocialWordCloudData,
  formatDataByPlatform,
  formatReachData,
  formatCitySpecificDataForLine,
  formatNewCitySpecificDataForLine,
  formatNewCitySpecificData
} from "./social-data-formatter";
import {
  formatTagAnalysisData,
  formatTagAnalysisDataByEntity,
} from "./social-data-formatter";
import SocialIcon from "../SocialIcon";
import { formatDataByTweetTypeSocial } from "./social-data-formatter/format-data-by-tweet-type";
import { formatDataByAuthorFollwingSocial } from "./social-data-formatter/format-data-by-author-following";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/wordcloud")(Highcharts);

const biuLogo = `https://${window.location.host}/static/media/conceptbiu-logo.2b6a4886.png`;
const {
  REPORTS: { TYPES },
  PRINT_ONLINE_COUNT_KEYS,
} = CONSTANTS;
const { FACEBOOK, INSTAGRAM, TWITTER, YOUTUBE, PINTEREST,LINKEDIN } = SOCIAL_SOURCES;

const {
  PIE,
  AREA,
  LINE,
  TABLE,
  WORD_CLOUD,
  GENDER,
  CHOROPLETH,
  DOUGHNUT,
  BAR_VERTICAL,
  BAR_STACKED,
  BAR_STACKED_EQUAL_HEIGHT,
} = GRAPH_TYPES;

const {
  JournalistNOATrend,
  JournalistAnalysisPrint,
  EditionWiseNOATrend,
  CityWiseNOATrend,
  CityWiseNOARanking,
  MediaWiseNOARanking,
  StateWiseTrend
} = REPORT_TYPES;

const {
  V_ONLINE,
  V_PRINT,
  V_BLOG,
  V_FORUM,
  V_SOCIAL,
  V_PRINT_AND_ONLINE,
  TWITTER_INSIGHTS,
  FACEBOOK_INSIGHTS,
  INSTAGRAM_INSIGHTS,
  LINKEDIN_INSIGHTS
} = VERTICALS;

export const Widget = ({
  widget,
  isDashboardWidget,
  isAnalysisReport,
  isEmbededWidget,
  setEmbededFeedsParams,
  selectedDashboard,
  showTodaysFeedWidget,
  handleTodayFeedWidgeStatus,
  fetchWidgets,
  setWidgetCreationStatus,
  selectedDataType,
  filteredWidgets,
  setFilteredWidgets,
  widgets,
  setWidgets,
  enableDownloadFn,
  preSelectedWCType,
  countryWiseFeeds,
  renderAnalysisWidget,
  contributedWidgetFilter: {
    preSelectedJournalist,
    preSelectedEdition,
    preSelectedState,
    preSelectedPublication,
    preSelectedInlineInfluencerEntity,
    preSelectedInlineWCEntity,
  },
  twitterFeeds,
  insightFeeds = 0,
  topicId,
  startRange,
  endRange,
  selectedFilter,
  tonality = false,
  tabData,
  widgetApiInProgress,
  setGraphRefList,
  setFromUserName,
  fromUserName = ""
}) => {
  const [graphApiResponse, setGraphApiResponse] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selectedInlinePublication, setSelectedInlinePublication] = useState(
    preSelectedPublication || null
  );
  const [selectedInlineJournalist, setSelectedInlineJournalist] = useState(
    preSelectedJournalist || null
  );
  const [selectedEdition, setSelectedEdition] = useState(
    preSelectedEdition || null
  );
  const [selectedState, setSelectedState] = useState(
    preSelectedState || undefined
  );
  const [dataByReportType, setDataByReportType] = useState([]);
  const [worldMapData, setWorldMapData] = useState([]);
  const [selectedInlineEntity, setSelectedInlineEntity] = useState("");
  const [feedsParams, setFeedsParams] = useState({});
  const [showFeedsList, setShowFeedsList] = useState(false);
  const [showPercentage, setShowPercentage] = useState(false);
  const [showWidgetConfig, setShowWidgetConfig] = useState(false);
  const [editWidgetData, setEditWidgetData] = useState({});
  const [inlineGraphTypeOptions, setInlineGraphOptions] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedInlineGraphType, setSelectedInlineGraphType] = useState(
    widget.graph_type
  );
  const [rawDataApiResponse, setRawApiResponse] = useState(undefined);
  const [showError, setShowError] = useState(false);
  const [useDateRange, setUseDateRange] = useState(false);
  const [entityListByType, setEntityListByType] = useState([]);
  const [selectedInlineWCType, setSelectedInlineWCType] = useState(
    preSelectedWCType || WORD_CLOUD_TYPE[1]
  );
  const [selectedInlinePlatform, setSelectedInlinePlatform] = useState(null);
  const [selectedInlineSentiment, setSelectedInlineSentiment] = useState("");
  const [selectedInlineWCEntity, setSelectedInlineWCEntity] = useState(
    preSelectedInlineWCEntity || null
  );
  const [selectedInlineInfluencerEntity, setSelectedInlineInfluencerEntity] =
    useState(preSelectedInlineInfluencerEntity || null);
  const [selectedInlineAuthorFollowingEntity, setSelectedInlineAuthorFollowingEntity] =
    useState(preSelectedInlineInfluencerEntity || null);
  const [selectedInlineAuthorTweetCountEntity, setSelectedInlineAuthorTweetCountEntity] =
    useState(preSelectedInlineInfluencerEntity || null);
  const [selectedInlineAuthorListedEntity, setSelectedInlineAuthorListedEntity] =
    useState(preSelectedInlineInfluencerEntity || null);
  const [selectedInlineAuthorLikeEntity, setSelectedInlineAuthorLikeEntity] =
    useState(preSelectedInlineInfluencerEntity || null);
  const [graphRef, setGraphRef] = useState("");
  const [twitterBreakDown, setTwitterBreakDown] = useState({});
  const [twitterBreakDownPie, setTwitterBreakDownPie] = useState([]);
  const [twitterBreakDownLine, setTwitterBreakDownLine] = useState([]);
  const [twitterMetricsData, setTwitterMetricsData] = useState([]);
  const [keyMetrics, setKeyMetrics] = useState([]);
  const [isSameDateReport, setIsSameDateReport] = useState(false);
  const [countType, setCountType] = useState("");
  const chartContainer = React.createRef();
  const initRef = useRef(false);
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  const editionList =
    useSelector(
      (state) => state.filterReducer && state.filterReducer.editionList
    ) || [];
  const stateList =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.state
    ) || [];
  const entityState =
    useSelector((state) => state.entityAndKeyWordsReducer) || {};

  const parentEntityId = entityState && entityState.parentEntityId;

  const {
    selectedEntity,
    entityDetails: { entityList },
    socialEntityList,
  } = entityState;

  const clientId = selectedClient && selectedClient.id;
  if (clientId == HOTSTAR_ID && widget.report_type == JournalistNOATrend) {
    widget.report_type = JournalistAnalysisPrint;
  }

  if (clientId == HOTSTAR_ID && widget.report_type == CityWiseNOATrend) {
    widget.report_type = EditionWiseNOATrend;
  }

  if (clientId == HOTSTAR_ID && widget.report_type == CityWiseNOARanking) {
    widget.report_type = MediaWiseNOARanking;
  }

  const hasClientAndEntity = clientId;
  const {
    id,
    from_date,
    to_date,
    graph_type,
    report_type,
    type, //vertical
    client_id,
    user_id,
    topic_ids,
    channel_type,
    edition,
    selectedMainPublication,
    publisher_type,
    selectedMainSentiment,
    language,
    selectedMainEdition,
    selectedMainPressRelease,
    selectedMainCountry,
    value_type,
    name,
  } = widget || {};
  const { DELETED } = HTTP_CODES;
  const isLineGraph = selectedInlineGraphType === LINE;
  const reportType = TYPES.filter((t) => t.id == report_type)[0];
  const isSocial = type == V_SOCIAL;
  const isBlogAndForum = type == V_BLOG || type == V_FORUM;
  const isPrintAndOnline = type == V_PRINT || type == V_ONLINE;
  const dateHash = `${getTrendGraphDateFormat(
    from_date,
    null,
    "Do MMMM YYYY"
  )} to ${getTrendGraphDateFormat(to_date, null, "Do MMMM YYYY")}`;
  const identifier = removeSpace(`${report_type}-${type}-${user_id}`);
  useEffect(() => {
    setSelectedInlineGraphType(widget.graph_type);
  }, [widget.graph_type]);

  useEffect(() => {
    // if(report_type === REPORT_TYPES.TypeOfPost){
    //   setSelectedInlinePlatform({
    //     label: "Twitter",
    //     value: TWITTER,
    //     showInFilters: true,
    //     showInTypePost: true
    //   })
    // }
    // if(report_type === REPORT_TYPES.ShareRetweet){
    //   setSelectedInlinePlatform({
    //     label: "Twitter",
    //     value: TWITTER,
    //     showInFilters: true,
    //     showInTypePost: true,
    //     showInShareRetweet : true
    //   })
    // }
    // if(report_type === REPORT_TYPES.ReplyComment){
    //   setSelectedInlinePlatform({
    //     label: "Twitter",
    //     value: TWITTER,
    //     showInFilters: true,
    //     showInTypePost: true,
    //     showInShareRetweet : true,
    //     showInReplyComment : true
    //   })
    // }
  },[report_type])

  useEffect(() => {
    if (isSocial && twitterFeeds && topicId && widgetApiInProgress) {
      fetchTwitterBreakDownGraph();
      fetchTwitterMetrics();
    }
  }, [topicId, tabData]);

  useEffect(() => {
    if (isSocial && insightFeeds != 0 && topicId && widgetApiInProgress) {
      fetchBreakDownGraph(insightFeeds);
      fetchMetrics(insightFeeds);
    }
  }, [topicId, tabData, insightFeeds]);

  useEffect(() => {
    if (
      isSocial &&
      twitterFeeds &&
      startRange &&
      endRange &&
      widgetApiInProgress
    ) {
      fetchTwitterBreakDownGraph();
      fetchTwitterMetrics();
    }
  }, [startRange, endRange]);

  useEffect(() => {
    if (
      isSocial &&
      insightFeeds != 0 &&
      startRange &&
      endRange &&
      widgetApiInProgress
    ) {
      fetchBreakDownGraph(insightFeeds);
      fetchMetrics(insightFeeds);
    }
  }, [startRange, endRange, insightFeeds]);

  useState(() => {
    let opts = GRAPH_TYPE_OPTIONS.filter(
      (opt) =>
        reportType && reportType.excludeGraphType.indexOf(opt.value) === -1
    );
    const listWithTable = opts.filter((elm) => elm.value == TABLE);
    if (!listWithTable || (!listWithTable.length && !twitterFeeds && insightFeeds != 0)) {
      opts = [
        ...opts,
        {
          value: TABLE,
          label: "Table",
        },
      ];
    }
    setInlineGraphOptions(opts);
  }, [isEmbededWidget]);

  useEffect(() => {
    const chartHeight = isEmbededWidget ? 400 : 283;
    Highcharts.setOptions({
      chart: {
        height: chartHeight,
      },
      credits: {
        enabled: false,
      },
      series: {
        symbol: "circle",
      },
      yAxis: {
        tickAmount: 10,
        allowDecimals: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          groupPadding: "0.1",
        },
        series: {
          lineWidth: 1,
          marker: {
            radius: 3,
          },
          dataLabels: {
            formatter: function () {
              if (this.y > 0) return this.y;
            },
            allowOverlap: false,
            shadow: false,
            style: {
              fontWeight: "normal",
              fontSize: "10px",
              textShadow: false,
              textOutline: "none",
            },
          },
        },
      },
      legend: {
        layout: "horizontal",
        y: -10,
        align: "center",
        verticalAlign: "top",
        floating: false,
        alignColumns: false,
        margin: 0,
        itemDistance: 10,
        itemMarginBottom: 5,
        itemMarginTop: 0,
        itemStyle: {
          fontSize: "12px",
          fontWeight: "normal",
          color: "#666",
        },
        symbolHeight: 11,
        symbolWidth: 11,
        symbolRadius: 0,
        maxHeight: 65,
      },
      colors: [
        "#E96F6F",
        "#FCC023",
        "#D63548",
        "#0979E4",
        "#AF8BAF",
        "#ADB842",
        "#9D402B",
        "#034249",
        "#4B83BB",
        "#D974A2",
        "#FF6362",
        "#900B3F",
        "#F2A364",
        "#A2C4C6",
        "#C39D4C",
        "#A1D981",
        "#FFA299",
        "#FFA299",
      ],
      exporting: {
        sourceWidth: 1500,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
          title: {
            y: 100,
          },
          chart: {
            height: 600,
            width: 600,
            marginTop: 180,
            events: {
              load: function () {
                var renderer = this.renderer;
                renderer
                  .text(
                    `${getTimelineText()}`,
                    getTimelineTextPosition(getTimelineText()),
                    80
                  )
                  .add();
                renderer
                  .text(
                    `${getInlineFilterText()} `,
                    getTimelineTextPosition(getInlineFilterText()),
                    95
                  )
                  .add();
                renderer
                  .image(LOGO.biuLogoBase, 725, 10, 50, 50)
                  .attr({
                    align: "center",
                  })
                  .add();
              },
            },
          },
        },
      },
    });

    setTimeout(() => {
      setUseDateRange(true);
    }, 3000);
  }, [
    dateHash,
    feedsParams,
    selectedInlineJournalist,
    selectedInlineGraphType,
    selectedInlinePlatform,
    selectedInlinePublication,
    selectedInlineSentiment,
    selectedInlineEntity,
  ]);
  useEffect(() => {
    try {
      if (!twitterFeeds && insightFeeds == 0 && (isSocial || isBlogAndForum) && report_type !== REPORT_TYPES.TopPostersTrend && report_type !== REPORT_TYPES.InfluencerWithDetail) {
        selectedInlineGraphType == CHOROPLETH
          ? fetchWorldMapData()
          : fetchSocialGraph();
      } else if (isPrintAndOnline && !twitterFeeds && insightFeeds == 0) {
        fetchGraph();
      } else if ((twitterFeeds || insightFeeds != 0) && isSocial && topicId) {
      } else {
        console.log("Unsupported type", type);
      }
    } catch (e) {
      console.log("Error in graph", e);
    }
  }, [
    id,
    // TODO: Remove after the conclusion on inline filter
    selectedEdition && selectedEdition.value,
    selectedState && selectedState.value,
    hasClientAndEntity,
    selectedMainPublication,
    report_type,
    selectedInlinePublication,
    selectedInlineJournalist,
    selectedInlineWCType,
    selectedInlineSentiment,
    selectedMainSentiment,
    selectedMainEdition,
    selectedInlinePlatform,
    selectedMainCountry,
    selectedInlineEntity,
    selectedInlineWCEntity,
    selectedInlineInfluencerEntity,
    selectedInlineAuthorFollowingEntity,
    selectedInlineAuthorTweetCountEntity,
    selectedInlineAuthorListedEntity,
    selectedInlineAuthorLikeEntity,
    topicId,
  ]);

  useEffect(() => {
    try {
      if (isSocial && (report_type === REPORT_TYPES.TopPostersTrend || report_type === REPORT_TYPES.InfluencerWithDetail)) {
        fetchSocialGraph();
      }
    } catch (e) {
      console.log("Error in graph", e);
    }
  },[
    selectedEdition && selectedEdition.value,
    hasClientAndEntity,
    selectedMainPublication,
    report_type,
    selectedInlinePublication,
    selectedInlineJournalist,
    selectedInlineWCType,
    selectedInlineSentiment,
    selectedMainSentiment,
    selectedMainEdition,
    selectedInlinePlatform,
    selectedMainCountry,
    selectedInlineEntity,
    selectedInlineWCEntity,
    selectedInlineInfluencerEntity,
    selectedInlineAuthorFollowingEntity,
    selectedInlineAuthorTweetCountEntity,
    selectedInlineAuthorListedEntity,
    selectedInlineAuthorLikeEntity,
    topicId,
    fromUserName
  ])

  useEffect(() => {
    if (!useDateRange) return;
    if (isAnalysisReport || isDashboardWidget) {
      if (!isPrintAndOnline) {
        selectedInlineGraphType == CHOROPLETH
          ? fetchWorldMapData()
          : fetchSocialGraph();
      } else {
        fetchGraph();
      }
    }
  }, [dateHash]);

  useEffect(() => {
    setShowPercentage(selectedDataType === DATA_TYPES.PERCENTAGE);
  }, [selectedDataType]);

  useEffect(() => {
    if (isPrintAndOnline) {
      setGraphApiResponse(formatedData(rawDataApiResponse));
    } else {
      setGraphApiResponse(formatSocialDataForAnalysis(rawDataApiResponse));
    }
  }, [selectedInlineGraphType]);

  useEffect(() => {
    try {
      if (!isLoading) {
        if (report_type === REPORT_TYPES.WorldMap) {
          setShowError(!worldMapData || !worldMapData.length);
          return;
        }
        if (report_type == REPORT_TYPES.TopPostersWithDetail) {
          if (
            selectedInlineGraphType == BAR_VERTICAL ||
            selectedInlineGraphType == BAR_STACKED ||
            selectedInlineGraphType == BAR_STACKED_EQUAL_HEIGHT
          ) {
            setShowError(
              !graphApiResponse ||
                !graphApiResponse.datasets ||
                !graphApiResponse.datasets.length ||
                !graphApiResponse.labels ||
                !graphApiResponse.labels.length
            );
            return;
          }
        }
        if (
          report_type === REPORT_TYPES.INFLUENCERS ||
          report_type === REPORT_TYPES.KEYINFLUENCERS ||
          report_type === REPORT_TYPES.TopPostersWithDetail ||
          report_type === REPORT_TYPES.KeywordCloudNOA ||
          report_type === REPORT_TYPES.MediaExposureReport ||
          report_type === REPORT_TYPES.AuthorFollowing ||
          report_type === REPORT_TYPES.AuthorTweetCount ||
          report_type === REPORT_TYPES.AuthorListed ||
          report_type === REPORT_TYPES.AuthorLike ||
          report_type === REPORT_TYPES.AuthorCreated
        ) {
          setShowError(!graphApiResponse || !graphApiResponse.length);
          return;
        }
        if (
          selectedInlineGraphType === TABLE &&
          report_type === REPORT_TYPES.Reach
        ) {
          if (!graphApiResponse || !graphApiResponse.length) {
            setShowError(true);
            return;
          }
          let nonZeroValues = graphApiResponse.filter(
            (d) => d.reach_count && d.reach_count != "0"
          );
          let containsAllZeroValues = !nonZeroValues || !nonZeroValues.length;
          setShowError(containsAllZeroValues);
          return;
        }
        if (
          !graphApiResponse ||
          !graphApiResponse.datasets ||
          !graphApiResponse.datasets.length ||
          !graphApiResponse.labels ||
          !graphApiResponse.labels.length
        ) {
          setShowError(true);
        } else {
          let continueLoop = true;
          let containsAllZeroValues = false;
          graphApiResponse.datasets.forEach((ds) => {
            if (!ds || !ds.data || !continueLoop) {
              setShowError(true);
              return;
            }
            if (
              (report_type === REPORT_TYPES.CitySpecificReport || report_type === REPORT_TYPES.citywisenew) &&
              graph_type !== BAR_STACKED &&
              graph_type !== BAR_STACKED_EQUAL_HEIGHT
            ) {
              const nonZeroValues = ds.data.filter(
                (d) => d && d.count?.toString() != "0"
              );
              if (nonZeroValues && nonZeroValues.length) {
                continueLoop = false;
              }
              containsAllZeroValues = !nonZeroValues || !nonZeroValues.length;
            } else {
              const nonZeroValues = ds.data.filter(
                (d) => d && d.toString() != "0"
              );
              if (nonZeroValues && nonZeroValues.length) {
                continueLoop = false;
              }
              containsAllZeroValues = !nonZeroValues || !nonZeroValues.length;
            }
          });
          setShowError(containsAllZeroValues);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }, [graphApiResponse, worldMapData, isLoading]);

  useEffect(() => {
    if (type == V_PRINT || type == V_ONLINE) {
      setEntityListByType(entityList);
    }
    if (type == V_SOCIAL || type == V_BLOG || type == V_FORUM) {
      setEntityListByType(socialEntityList);
    }
  }, [type]);

  useEffect(() => {
    setShowPercentage(value_type == DATA_TYPES.P_TEXT);
  }, [value_type]);

  useEffect(() => {
    setIsSameDateReport(moment(to_date).isSame(moment(from_date), "day"));
  }, [to_date, from_date]);

  if (!reportType) {
    return null;
  }

  function getTimelineText() {
    let defText = "Report for the duration ";
    if (moment(to_date).isSame(moment(from_date), "day")) {
      defText = `${defText}${getTrendGraphDateFormat(
        from_date,
        null,
        "Do MMMM YYYY"
      )}`;
    } else {
      defText = `${defText}${dateHash}`;
    }
    return defText;
  }
  function getInlineFilterText() {
    try {
      let text = `Media Type- ${VERTICAL_NAMES[widget.type]} | `;
      if (selectedInlineJournalist && selectedInlineJournalist.label) {
        text += `Journalist- ${selectedInlineJournalist.label} | `;
      }
      if (selectedInlinePlatform) {
        text += `Platform- ${selectedInlinePlatform} | `;
      }
      if (selectedInlinePublication && selectedInlinePublication.length) {
        text += `Publication- ${selectedInlinePublication.join(",")} | `;
      }
      if (selectedInlineSentiment) {
        text += `Sentiment- ${selectedInlineSentiment} | `;
      }
      if (
        widget.graph_type == WORD_CLOUD &&
        (isBlogAndForum || isSocial) &&
        selectedInlineWCType &&
        selectedInlineWCType.label
      ) {
        text += `${selectedInlineWCType.label}  `;
      }
      return text.slice(0, -2);
    } catch (e) {
      console.warn("[Error @ widget inline filter text]: ", e);
      return "";
    }
  }

  function getTimelineTextPosition(str) {
    // console.log("getTimelineTextPosition", str, str.length);
    return 725 - str.length * 2.5;
    // if (moment(to_date).isSame(moment(from_date), "day")) {
    //   return 620;
    // } else {
    //   return 570;
    // }
  }

  function getCorrectPublication() {
    // selectedMainPublication => Top level analysis filter.
    // selectedInlinePublication => Widget level inline filter.
    if (!selectedMainPublication && !selectedInlinePublication) {
      return null;
    }

    if (selectedInlinePublication && selectedInlinePublication.value) {
      return [selectedInlinePublication.value];
    }

    return Array.isArray(selectedMainPublication)
      ? selectedMainPublication.map((e) => e && e.id)
      : (selectedMainPublication && selectedMainPublication.id) || [];
  }

  function getCorrectEntity() {
    if (isAnalysisReport) {
      if (selectedInlineEntity) {
        return [selectedInlineEntity.value];
      }
      if (Array.isArray(topic_ids)) {
        return topic_ids;
      }
      return [];
    } else {
      if (widget.topic_ids) {
        return widget.topic_ids;
      }
      if (Array.isArray(selectedEntity)) {
        return selectedEntity.map((el) => el && el.id);
      } else {
        return [];
      }
    }
  }

  function getCorrectSourceId() {
    if (selectedInlineJournalist && selectedInlineJournalist.value) {
      return [selectedInlineJournalist.value];
    } else {
      return [];
    }
  }

  function getCorrectSentiment() {
    if (type == V_SOCIAL) {
      if (selectedMainSentiment && selectedMainSentiment.length) {
        return selectedMainSentiment;
      }
      if (selectedInlineSentiment && selectedInlineSentiment.value) {
        return [selectedInlineSentiment.value];
      }
    } else {
      if (selectedMainSentiment && selectedMainSentiment.length) {
        return selectedMainSentiment;
      }
      if (selectedInlineSentiment && selectedInlineSentiment.id) {
        return [selectedInlineSentiment.id];
      }
    }
    return null;
  }

  function getCorrectEdition() {
    if (selectedMainEdition && selectedMainEdition.length) {
      return [selectedMainEdition];
    }
    if (selectedEdition && selectedEdition.value) {
      return [selectedEdition.value];
    }
    return null;
  }

  function getCorrectChannelType(clickedCType) {
    if (type != V_SOCIAL) {
      return null;
    }
        const correctedCType = clickedCType || channel_type;    
    if (selectedInlinePlatform) {
      return [selectedInlinePlatform.value];
    }
    if (correctedCType) {
      // https://webonise.atlassian.net/browse/CB-642
      if (
        report_type == REPORT_TYPES.SOVTonality ||
        report_type == REPORT_TYPES.PLATFORM_TONALITY
      ) {
        if (Array.isArray(correctedCType)) {
          if (!correctedCType.length) {
            return [FACEBOOK, INSTAGRAM, TWITTER];
          } else {
            return correctedCType.map((elm) => (elm == YOUTUBE && report_type != REPORT_TYPES.SOVTonality ? 99 : elm));
          }
        }
        // Returning garbage value to avoid youtube data when non of the platform is selected.
        if (correctedCType == YOUTUBE) return [99];
      } else
        return Array.isArray(correctedCType)
          ? correctedCType
          : [correctedCType];
    } else {
      if (
        report_type == REPORT_TYPES.SOVTonality ||
        report_type == REPORT_TYPES.PLATFORM_TONALITY
      ) {
        return [FACEBOOK, INSTAGRAM, TWITTER];
      }
      return null;
    }
  }

  function fetchGraph() {
    try {
      setIsLoading(true);
      const callApi =
        isPrintAndOnline && clientId && to_date && from_date && topic_ids;
      if (!callApi || !reportType || !hasClientAndEntity) {
        console.log("Missing params");
        return;
      }
      initRef.current = true;
      const {
        graphDataType: { print, online },
      } = reportType;
      const params = {
        client_id: client_id || clientId,
        fromDate: formatDate(from_date, DATE_FORMATS.YYYYMMDD_dash),
        toDate: formatDate(to_date, DATE_FORMATS.YYYYMMDD_dash),
        getreport: "",
        graphs_data: [type == V_PRINT ? print : online],
        media_type: String(type),
        user_id: user_id || getConceptUserId(),
        website_type_id : selectedClient && selectedClient.website_type_id
      };
      const tempEntityList = getCorrectEntity();
      const tempSourceId = getCorrectSourceId();
      const tempPublication = getCorrectPublication();
      console.log(tonality,"lie 948")
      const tempSentiment = (!tonality && report_type != StateWiseTrend) 
        ? getCorrectSentiment()
        : selectedInlineSentiment && selectedInlineSentiment.id
        ? getCorrectSentiment()
        : CONSTANTS.TONALITY.map(({ id }) => id);
      const tempEdition = getCorrectEdition();
      if (tempSourceId && tempSourceId.length) {
        if (
          report_type == JournalistAnalysisPrint ||
          report_type == EditionWiseNOATrend
        ) {
          params.entity = tempSourceId;
        } else {
          params.source_ids = tempSourceId;
        }
      }
      if (tempPublication && tempPublication.length) {
        params.selected_publications = tempPublication;
      }
      if (publisher_type && publisher_type.length) {
        params.publisher_type = publisher_type;
      }
      if (tempEdition && tempEdition.length) {
        params.edition = tempEdition;
      }
      if (
        tempEntityList &&
        tempEntityList.length &&
        report_type != JournalistAnalysisPrint &&
        report_type != EditionWiseNOATrend
      ) {
        params.entity = tempEntityList;
      }
      if (tempSentiment && tempSentiment.length) {
        params.tonality_ids = tempSentiment;
      }
      if (selectedMainPressRelease && selectedMainPressRelease.length) {
        params.pressrelease_ids = [selectedMainPressRelease];
      }
      if(selectedState){
        params.state = selectedState.value
      }
      let url = envConfig.REPORTS
      let graph_name_new_url = ['CityWisePrint','TopPublicationOnline','TopJournalistDataOnline','TrendAnalysisPrint','SovClientCompetitorsPrint','TopPublicationPrint','TopJournalistDataPrint','SovClientCompetitorOnline']
      let filteredArray = params.graphs_data.filter(value => graph_name_new_url.includes(value));
      if(filteredArray.length > 0)
      {
       url = unifiedEnvConfig.REPORTNEW
      }
      httpPost(`${url}`, params)
        .then((response) => {
          const {
            data: { result },
          } = response || {};
          if (result) {
            setRawApiResponse(result);
            setIsLoading(false);
            const res = formatedData(result);
            setGraphApiResponse(res);
            const {
              graphDataType: { print, online },
            } = reportType;
            const rType = type === V_PRINT ? print : online;
            let dataByReportType = result[rType] && result[rType].returnData;
            if (report_type === JournalistAnalysisPrint) {
              dataByReportType = Object.values(dataByReportType).flat(1);
            }
            if (dataByReportType) {
              setDataByReportType(dataByReportType);
            } else {
              setDataByReportType([]);
            }
          } else {
            console.log("[Error]", response);
            setIsLoading(false);
          }
        })
        .catch(() => {})
        .finally((data) => {
          enableDownloadFn && enableDownloadFn(id);
          initRef.current = true;
        });
    } catch (e) {
      initRef.current = true;
      console.log("[Error]", e);
      setIsLoading(false);
    }
  }

  const fetchTwitterBreakDownGraph = () => {
    if (widgetApiInProgress) {
      setIsLoading(true);
      const fromDate = moment(startRange).format("MM/DD/YYYY");
      const toDate = moment(endRange).format("MM/DD/YYYY");
      if (topicId) {
        httpGet(
          `${unifiedEnvConfig.TWITTER_BREAKDOWN}?topic_id=${topicId}&client_id=${clientId}&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}`
        )
          .then((res) => {
            const { by_date, total } = res.data.data;
            setTwitterBreakDownPie(total);
            setTwitterBreakDownLine(by_date);
            setTwitterBreakDown(res.data.data);
          })
          .finally(() => {
            setIsLoading(false);
            enableDownloadFn && enableDownloadFn(id);
          });
      }
    }
  };

  const fetchBreakDownGraph = (channelId) => {
    if (widgetApiInProgress) {
      setIsLoading(true);
      const fromDate = moment(startRange).format("MM/DD/YYYY");
      const toDate = moment(endRange).format("MM/DD/YYYY");
      if (topicId) {
        let filterData = `topic_id=${topicId}&client_id=${clientId}&channel_id=${channelId}&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}`
        if(Array.isArray(language) && language.length){
          language.forEach((tLang) => {
            filterData+=`&searchParams[lang][]=${tLang}`
          })
        }
        else if(!Array.isArray(language) && language.length){
          filterData+=`&searchParams[lang]=${language}`
        }
        httpGet(
          `${unifiedEnvConfig.BREAKDOWN}?${filterData}`
        )
          .then((res) => {
            const { by_date, total } = res.data.data;
            setTwitterBreakDownPie(total);
            setTwitterBreakDownLine(by_date);
            setTwitterBreakDown(res.data.data);
          })
          .finally(() => {
            setIsLoading(false);
            enableDownloadFn && enableDownloadFn(id);
          });
      }
    }
  };

  const fetchTwitterMetrics = () => {
    if (widgetApiInProgress) {
      setIsLoading(true);
      const fromDate = moment(startRange).format("MM/DD/YYYY");
      const toDate = moment(endRange).format("MM/DD/YYYY");
      if (topicId) {
        httpGet(
          `${unifiedEnvConfig.TWITTER_METRICS}?topic_id=${topicId}&client_id=${clientId}&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}`
        )
          .then((res) => {
            const { by_date, total } = res.data.data;
            setTwitterMetricsData(by_date);
            setKeyMetrics(total);
          })
          .finally(() => {
            setIsLoading(false);
            enableDownloadFn && enableDownloadFn(id);
          });
      }
    }
  };

  const fetchMetrics = (channelId) => {
    if (widgetApiInProgress) {
      setIsLoading(true);
      const fromDate = moment(startRange).format("MM/DD/YYYY");
      const toDate = moment(endRange).format("MM/DD/YYYY");
      if (topicId) {
        httpGet(
          `${unifiedEnvConfig.INSIGHT_METRICS}?topic_id=${topicId}&client_id=${clientId}&channel_id=${channelId}&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}`
        )
          .then((res) => {
            const { by_date, total } = res.data.data;
            setTwitterMetricsData(by_date);
            setKeyMetrics(total);
          })
          .finally(() => {
            setIsLoading(false);
            enableDownloadFn && enableDownloadFn(id);
          });
      }
    }
  };

  function fetchSocialGraph() {
    let client_Id =
      parentEntityId && parentEntityId !== clientId ? parentEntityId : clientId;
    if (isLoading && !isSocial && !isBlogAndForum && !client_Id) {
      return;
    }
    const influencerEnt =
      socialEntityList &&
      socialEntityList.values.length &&
      socialEntityList.values.map(({ id, entity_name }) => {
        return {
          value: id,
          label: entity_name,
        };
      })[0];
    initRef.current = true;
    setIsLoading(true);
    if (
      report_type === REPORT_TYPES.Reach ||
      report_type === REPORT_TYPES.INFLUENCERS ||
      report_type === REPORT_TYPES.KEYINFLUENCERS ||
      report_type == REPORT_TYPES.TopPostersWithDetail ||
      report_type == REPORT_TYPES.TopPostersTrend ||
      report_type == REPORT_TYPES.InfluencerWithDetail ||
      report_type == REPORT_TYPES.AuthorFollowing ||
      report_type == REPORT_TYPES.AuthorTweetCount ||
      report_type == REPORT_TYPES.AuthorListed ||
      report_type == REPORT_TYPES.AuthorLike ||
      report_type == REPORT_TYPES.AuthorCreated 
    ) {
            // TODO payload changes - (social filter for analysis page )
      const payload =
        report_type === REPORT_TYPES.KEYINFLUENCERS
          ? {
              report_type: report_type + "",
              from_date: getSocialApiDateFormat(from_date),
              to_date: getSocialApiDateFormat(to_date),
              type: type,
            }
          : {
              report_type: report_type + "",
              from_date: getSocialApiDateFormat(from_date),
              to_date: getSocialApiDateFormat(to_date),
              channel_type: getCorrectChannelType(),
              word_cloud_type:
                selectedInlineWCType && selectedInlineWCType.value,
              from_username : fromUserName, 
              topic_ids:
                report_type === REPORT_TYPES.INFLUENCERS || report_type === REPORT_TYPES.AuthorCreated
                  ? (selectedInlineInfluencerEntity
                    ? [parseInt(selectedInlineInfluencerEntity.value)]
                    : [topic_ids[0]])
                  :(report_type === REPORT_TYPES.AuthorFollowing
                    ? (selectedInlineAuthorFollowingEntity
                      ? [parseInt(selectedInlineAuthorFollowingEntity.value)]
                      : [topic_ids[0]])
                    :(report_type === REPORT_TYPES.AuthorTweetCount
                      ? (selectedInlineAuthorTweetCountEntity
                        ? [parseInt(selectedInlineAuthorTweetCountEntity.value)]
                        : [topic_ids[0]])
                      :(report_type === REPORT_TYPES.AuthorListed
                        ? (selectedInlineAuthorListedEntity
                          ? [parseInt(selectedInlineAuthorListedEntity.value)]
                          : [topic_ids[0]])
                        :(report_type === REPORT_TYPES.AuthorLike
                          ? (selectedInlineAuthorLikeEntity
                            ? [parseInt(selectedInlineAuthorLikeEntity.value)]
                            : [topic_ids[0]])
                          : topic_ids)))),
              tonality: selectedMainSentiment,
              country: (selectedMainCountry ? [selectedMainCountry] : null),
              language: language,
              type: type,
            };
      httpPost(
        `${unifiedEnvConfig.SOCIAL_GRAPH}?client_id=${client_Id}`,
        payload
      )
        .then((response) => {
          if (response && response.data) {
            const rawResponse = response.data.data;
            setGraphApiResponse(
              formatSocialDataForAnalysis(response.data.data)
            );
            setRawApiResponse(rawResponse);
          }
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
          enableDownloadFn && enableDownloadFn(id);
        });
    } else {
            httpPost(`${unifiedEnvConfig.SOCIAL_GRAPH}?client_id=${client_Id}`, {
        report_type: report_type + "",
        from_date: getSocialApiDateFormat(from_date),
        to_date: getSocialApiDateFormat(to_date),
        channel_type: twitterFeeds
          ? SOCIAL_SOURCES.TWITTER
          :(insightFeeds !== 0?insightFeeds: getCorrectChannelType()),
        word_cloud_type: selectedInlineWCType && selectedInlineWCType.value,
        topic_ids: twitterFeeds
          ? topicId
          : report_type === REPORT_TYPES.KeywordCloudNOA
          ? selectedInlineWCEntity
            ? [parseInt(selectedInlineWCEntity.value)]
            : [topic_ids[0]]
          : topic_ids,
        tonality: getCorrectSentiment(),
        //Added default country for city wise as per shringesh
        country: (report_type === REPORT_TYPES.citywisenew?"India":(selectedMainCountry ? [selectedMainCountry] : null)),
        language: language?(Array.isArray(language) && language.length ?language:(report_type === REPORT_TYPES.TopLanguages?LANGUAGE_CODE:[language])):null,
        type: type,
        date_granularity: "day",
      })
        .then((response) => {
          if (response && response.data) {
            const rawResponse = response.data.data;
            setGraphApiResponse(formatedSocialData(rawResponse));
            setRawApiResponse(rawResponse);
          }
        })
        .finally(() => {
          setIsLoading(false);
          enableDownloadFn && enableDownloadFn(id);
        });
    }
  }

  function formatSocialDataForAnalysis(data) {
    if (!data) return;
    if (report_type === REPORT_TYPES.Reach) {
      if (selectedInlineGraphType === TABLE) {
        return data.graph_data;
      } else {
        return formatReachData(
          data.graph_data,
          selectedInlineGraphType,
          isLineGraph
        );
      }
    }
    if (
      report_type == REPORT_TYPES.INFLUENCERS ||
      report_type == REPORT_TYPES.KEYINFLUENCERS
    ) {
      // Remove after API has non empty response.
      return formatInfluencersData(data, report_type);
    }
    if (
      report_type == REPORT_TYPES.AuthorFollowing
    ) {
      // Remove after API has non empty response.
      return formatAuthorFollowingData(data, report_type);
    }
    if (
      report_type == REPORT_TYPES.AuthorTweetCount
    ) {
      // Remove after API has non empty response.
      return formatAuthorTweetCountData(data, report_type);
    }
    if (
      report_type == REPORT_TYPES.AuthorListed
    ) {
      // Remove after API has non empty response.
      return formatAuthorListedData(data, report_type);
    }
    if (
      report_type == REPORT_TYPES.AuthorCreated
    ) {
      // Remove after API has non empty response.
      return formatAuthorCreatedData(data, report_type);
    }
    if (
      report_type == REPORT_TYPES.AuthorLike
    ) {
      // Remove after API has non empty response.
      return formatAuthorLikeData(data, report_type);
    }
    if (report_type == REPORT_TYPES.TopPostersWithDetail) {
      if (
        selectedInlineGraphType == BAR_VERTICAL ||
        selectedInlineGraphType == BAR_STACKED ||
        selectedInlineGraphType == BAR_STACKED_EQUAL_HEIGHT
      ) {
        return formatTopPostersDataForGraph(
          formatTopPostersData(data.graph_data)
        );
      } else {
        return formatTopPostersData(data.graph_data);
      }
    }
    // if (report_type == REPORT_TYPES.TopPostersTrend) {
    //   if (
    //     selectedInlineGraphType == BAR_VERTICAL ||
    //     selectedInlineGraphType == BAR_STACKED ||
    //     selectedInlineGraphType == BAR_STACKED_EQUAL_HEIGHT
    //   ) {
    //     return formatTopPostersTrendDataForGraph(
    //       formatTopPostersTrendData(data.graph_data)
    //     );
    //   } else {
    //     return formatTopPostersTrendData(data.graph_data);
    //   }
    // }
    if (report_type == REPORT_TYPES.CitySpecificReport) {
      if (
        graph_type === BAR_STACKED ||
        graph_type === BAR_STACKED_EQUAL_HEIGHT
      ) {
        return formatCitySpecificDataForLine(data, isLineGraph);
      }
    }
    if (report_type == REPORT_TYPES.citywisenew) {
      if (
        graph_type === BAR_STACKED ||
        graph_type === BAR_STACKED_EQUAL_HEIGHT
      ) {
        return formatNewCitySpecificDataForLine(data, isLineGraph);
      }
    }
    if (report_type == REPORT_TYPES.TagBasedTagAnalysis) {
      if (graph_type === BAR_STACKED_EQUAL_HEIGHT || graph_type === TABLE) {
        return formatTagAnalysisData(data);
      }
    }
    if (report_type == REPORT_TYPES.EntityBasedTagAnalysis) {
      if (graph_type === BAR_STACKED_EQUAL_HEIGHT || graph_type === TABLE) {
        return formatTagAnalysisDataByEntity(data);
      }
    }
    return formatedSocialData(data);
  }
  const formatTopPostersData = (data) => {
    try {
      let formatedData = [];
      data.map(({ post_count, topic_id, topic_category, topic_name }) => {
        post_count.forEach(({ from_username, count, channel_type, likes_count, tweets_count, follower_count }, i) => {
          // if (from_username && i < 10) {
          if (from_username) {
            formatedData.push({
              from_username,
              count,
              topic_id,
              topic_category,
              topic_name,
              channel_type,
              likes_count,
              tweets_count,
              // listed_count,
              follower_count,
            });
          }
        });
      });
      return formatedData.sort((a, b) => +b.count - +a.count);
    } catch (e) {
      console.log(e);
      return [];
    }
  };

  const formatTopPostersDataForGraph = (d) => {
    try {
      const userList = d.map((infoObj) => `@${infoObj.from_username}`);
      if (!userList) {
        return null;
      }
      const entityList = d.map((infoObj) => infoObj.topic_name);
      const uniqueEntityList = [...new Set(entityList)];

      const graphColors = getRandomUniqueColor(
        userList.length + uniqueEntityList.length
      );
      let datasets = uniqueEntityList.map((entityName, index) => {
        const data = d.map((infoObj) => {
          if (infoObj.topic_name === entityName) {
            return +infoObj.count;
          }
          return 0;
        });
        return {
          label: entityName,
          data,
          backgroundColor: graphColors[index],
        };
      });
      return {
        labels: userList,
        datasets,
      };
    } catch (e) {
      return {
        labels: [],
        datasets: [],
      };
    }
  };

  // fetch and combine feeds data for all selected topics
  function fetchWorldMapData() {
    const mapData = [];
    initRef.current = true;
    setIsLoading(true);
    if (topic_ids) {
      httpPost(`${unifiedEnvConfig.SOCIAL_GRAPH}?client_id=${clientId}`, {
        report_type: report_type + "",
        from_date: getSocialApiDateFormat(from_date),
        to_date: getSocialApiDateFormat(to_date),
        channel_type: getCorrectChannelType(),
        word_cloud_type: "",
        topic_ids: topic_ids,
        tonality: getCorrectSentiment(),
        country: selectedMainCountry ? [selectedMainCountry] : null,
        language: language && language.length ? language : null,
        type: type,
      })
        .then((res) => {
          let {
            data: {
              data: { graph_data },
            },
          } = res;
          graph_data.forEach(({ data, topic_name, topic_id }) => {
            const tempData =
              (data &&
                data.map((elm) => ({ ...elm, topic_name, topic_id })).flat()) ||
              [];
            mapData.push(...tempData);
          });
          setWorldMapData([...mapData]);
          setIsLoading(false);
          enableDownloadFn && enableDownloadFn(id);
        })
        .catch((e) => console.log(e));
    } else {
      setIsLoading(false);
      setWorldMapData([]);
    }
  }

  function formatDataByCitySocial(d = []) {
    try {
      const graph_data = d.graph_data || [];
      const listOfEntities = graph_data.map((gd) => gd.topic_name);
      const labels = isLineGraph
        ? getLineGraphFormat(listOfEntities, true)
        : listOfEntities;
      const allCities = graph_data
        .map((gd) => gd.post_count)
        .flat()
        .map((gd) => gd.city)
        .filter(Boolean)
        .filter(onlyUnique);
      if (selectedInlineGraphType === GENDER) {
        return {
          mValue: 40,
          fValue: 60,
        };
      }
      const datasets = allCities.map((city, index) => {
        const tempArr = graph_data.map((topic) => {
          const topicPost = topic.post_count.filter(
            (pc) => pc.city === city
          )[0];
          return topicPost ? topicPost.count : 0;
        });
        const data = isLineGraph ? getLineGraphFormat(tempArr) : tempArr;
        const graphColors = getRandomUniqueColor(allCities.length);
        const tempColor = graphColors[index];
        const color =
          selectedInlineGraphType === AREA && typeof window.Color === "function"
            ? window.Color(tempColor).alpha(0.5).rgbString()
            : tempColor;
        return {
          data,
          label: city,
          backgroundColor: color,
          borderColor: color,
          fill: selectedInlineGraphType === AREA ? "start" : false,
        };
      });
      return {
        datasets,
        labels,
      };
    } catch (e) {
      return {
        datasets: [],
        labels: [],
      };
    }
  }

  function compareInfluencersData(a, b) {
    const key = "followers_count";
    if (a[key] < b[key]) {
      return 1;
    }
    if (a[key] > b[key]) {
      return -1;
    }
    return 0;
  }

  function compareAuthorFollowingData(a, b) {
    const key = "following_count";
    if (a[key] < b[key]) {
      return 1;
    }
    if (a[key] > b[key]) {
      return -1;
    }
    return 0;
  }

  function compareAuthorTweetCountData(a, b) {
    const key = "tweets_count";
    if (a[key] < b[key]) {
      return 1;
    }
    if (a[key] > b[key]) {
      return -1;
    }
    return 0;
  }

  function compareAuthorListedData(a, b) {
    const key = "listed_count";
    if (a[key] < b[key]) {
      return 1;
    }
    if (a[key] > b[key]) {
      return -1;
    }
    return 0;
  }

  function compareAuthorCreatedData(a, b) {
    const key = "count";
    if (a[key] < b[key]) {
      return 1;
    }
    if (a[key] > b[key]) {
      return -1;
    }
    return 0;
  }

  function compareAuthorLikeData(a, b) {
    const key = "likes_count";
    if (a[key] < b[key]) {
      return 1;
    }
    if (a[key] > b[key]) {
      return -1;
    }
    return 0;
  }

  function formatInfluencersData(d = [], report_type) {
    if (report_type === REPORT_TYPES.INFLUENCERS) {
      let array = [];
      const data = d && d.graph_data ? d.graph_data : [];
      if (data && data.length) {
        data.forEach((item) => {
          const { topic_name, post_count } = item;
          if (post_count && post_count.length) {
            item.post_count.forEach((i) => {
              const { followers_count, from_username, count, user_image } = i;
              array.push({
                followers_count,
                from_username,
                topic_name,
                posts: count,
                user_image,
              });
            });
          }
        });
        return array.sort(compareInfluencersData);
      }
    }
    if (report_type === REPORT_TYPES.KEYINFLUENCERS) {
      let array = [];
      const { graph_data } = d;
      if (graph_data && graph_data.length) {
        graph_data.map((item) => {
          const { from_username, id, user_followers_count, user_image } = item;
          array.push({
            from_username,
            user_followers_count,
            id,
            user_image,
          });
        });
        return array.sort(compareInfluencersData);
      }
    }
    return [];
  }

  function formatAuthorFollowingData(d = [], report_type) {
    if (report_type === REPORT_TYPES.AuthorFollowing) {
      let array = [];
      const data = d && d.graph_data ? d.graph_data : [];
      if (data && data.length) {
        data.forEach((item) => {
          const { topic_name, post_data } = item;
          if (post_data && post_data.length) {
            item.post_data.forEach((i) => {
              const { following_count , profile_name } = i;
              array.push({
                following_count,
                profile_name,
                topic_name,
              });
            });
          }
        });
        return array.sort(compareAuthorFollowingData);
      }
    }
    // if (report_type === REPORT_TYPES.AuthorFollowing) {
    //   let array = [];
    //   const { graph_data } = d;
    //   console.log(graph_data);
    //   if (graph_data && graph_data.length) {
    //     graph_data.map((item) => {
    //       const { from_username, id, user_followers_count, user_image } = item;
    //       array.push({
    //         from_username,
    //         user_followers_count,
    //         id,
    //         user_image,
    //       });
    //     });
    //     return array.sort(compareInfluencersData);
    //   }
    // }
    return [];
  }

  function formatAuthorTweetCountData(d = [], report_type) {
    if (report_type === REPORT_TYPES.AuthorTweetCount) {
      let array = [];
      const data = d && d.graph_data ? d.graph_data : [];
      if (data && data.length) {
        data.forEach((item) => {
          const { topic_name, post_data } = item;
          if (post_data && post_data.length) {
            item.post_data.forEach((i) => {
              const { tweets_count , profile_name } = i;
              array.push({
                tweets_count,
                profile_name,
                topic_name,
              }); 
            });
          }
        });
        return array.sort(compareAuthorTweetCountData);
      }
    }
    // if (report_type === REPORT_TYPES.AuthorFollowing) {
    //   let array = [];
    //   const { graph_data } = d;
    //   console.log(graph_data);
    //   if (graph_data && graph_data.length) {
    //     graph_data.map((item) => {
    //       const { from_username, id, user_followers_count, user_image } = item;
    //       array.push({
    //         from_username,
    //         user_followers_count,
    //         id,
    //         user_image,
    //       });
    //     });
    //     return array.sort(compareInfluencersData);
    //   }
    // }
    return [];
  }

  function formatAuthorListedData(d = [], report_type) {
    if (report_type === REPORT_TYPES.AuthorListed) {
      let array = [];
      const data = d && d.graph_data ? d.graph_data : [];
      if (data && data.length) {
        data.forEach((item) => {
          const { topic_name, post_data } = item;
          if (post_data && post_data.length) {
            item.post_data.forEach((i) => {
              const { listed_count , profile_name } = i;
              array.push({
                listed_count,
                profile_name,
                topic_name,
              }); 
            });
          }
        });
        return array.sort(compareAuthorListedData);
      }
    }
    // if (report_type === REPORT_TYPES.AuthorFollowing) {
    //   let array = [];
    //   const { graph_data } = d;
    //   console.log(graph_data);
    //   if (graph_data && graph_data.length) {
    //     graph_data.map((item) => {
    //       const { from_username, id, user_followers_count, user_image } = item;
    //       array.push({
    //         from_username,
    //         user_followers_count,
    //         id,
    //         user_image,
    //       });
    //     });
    //     return array.sort(compareInfluencersData);
    //   }
    // }
    return [];
  }

  function formatAuthorCreatedData(d = [], report_type) {
    if (report_type === REPORT_TYPES.AuthorCreated) {
      let array = [];
      const data = d && d.graph_data ? d.graph_data : [];
      if (data && data.length) {
        data.forEach((item) => {
          const { topic_name, post_data } = item;
          if (post_data && post_data.length) {
            item.post_data.forEach((i) => {
              const { count , btrim } = i;
              array.push({
                count,
                profile_name : btrim,
                topic_name,
              }); 
            });
          }
        });
        return array.sort(compareAuthorCreatedData);
      }
    }
    // if (report_type === REPORT_TYPES.AuthorFollowing) {
    //   let array = [];
    //   const { graph_data } = d;
    //   console.log(graph_data);
    //   if (graph_data && graph_data.length) {
    //     graph_data.map((item) => {
    //       const { from_username, id, user_followers_count, user_image } = item;
    //       array.push({
    //         from_username,
    //         user_followers_count,
    //         id,
    //         user_image,
    //       });
    //     });
    //     return array.sort(compareInfluencersData);
    //   }
    // }
    return [];
  }

  function formatAuthorLikeData(d = [], report_type) {
    if (report_type === REPORT_TYPES.AuthorLike) {
      let array = [];
      const data = d && d.graph_data ? d.graph_data : [];
      if (data && data.length) {
        data.forEach((item) => {
          const { topic_name, post_data } = item;
          if (post_data && post_data.length) {
            item.post_data.forEach((i) => {
              const { likes_count , profile_name } = i;
              array.push({
                likes_count,
                profile_name,
                topic_name,
              }); 
            });
          }
        });
        return array.sort(compareAuthorLikeData);
      }
    }
    // if (report_type === REPORT_TYPES.AuthorFollowing) {
    //   let array = [];
    //   const { graph_data } = d;
    //   console.log(graph_data);
    //   if (graph_data && graph_data.length) {
    //     graph_data.map((item) => {
    //       const { from_username, id, user_followers_count, user_image } = item;
    //       array.push({
    //         from_username,
    //         user_followers_count,
    //         id,
    //         user_image,
    //       });
    //     });
    //     return array.sort(compareInfluencersData);
    //   }
    // }
    return [];
  }

  function formatedSocialData(d = []) {
    if (reportType.reportCategory == "platform") {
      // console.log(formatDataByPlatform(
      //   d,
      //   selectedInlineGraphType,
      //   isLineGraph,
      //   report_type,
      //   selectedInlinePlatform
      // ),d,
      // selectedInlineGraphType,
      // isLineGraph,
      // report_type);
      return formatDataByPlatform(
        d,
        selectedInlineGraphType,
        isLineGraph,
        report_type,
        selectedInlinePlatform
      );
    }
    if (report_type == REPORT_TYPES.WorldMap) {
      return fetchWorldMapData();
    }
    if (report_type == REPORT_TYPES.SOVRanking) {
      return formatSovRankingSocial(
        d,
        isLineGraph,
        selectedInlineGraphType,
        report_type
      );
    }
    if (report_type == REPORT_TYPES.SOVTonality) {
      return formatDataByTonalitySocial(
        d,
        isLineGraph,
        selectedInlineGraphType,
        report_type
      );
    }
    if (report_type == REPORT_TYPES.TypeOfPost) {
      if(selectedInlinePlatform != null && selectedInlinePlatform.value === TWITTER){
        return formatDataByTweetTypeSocial(
          d,
          isLineGraph,
          selectedInlineGraphType,
          report_type
        );
      }
      else{
        return formatDataByPlatform(
          d,
          selectedInlineGraphType,
          isLineGraph,
          report_type,
          selectedInlinePlatform
        );
      }
    }
    if (report_type == REPORT_TYPES.AuthorFollowing) {
      return formatDataByAuthorFollwingSocial(
        d,
        isLineGraph,
        selectedInlineGraphType,
        report_type
      );
    }
    if (report_type == REPORT_TYPES.SOVCity) {
      return formatDataByCitySocial(
        d,
        isLineGraph,
        selectedInlineGraphType,
        report_type
      );
    }
    if (report_type == REPORT_TYPES.KeywordCloudNOA) {
      return formatSocialWordCloudData(d);
    }
    if (report_type == REPORT_TYPES.CitySpecificReport) {
      if (
        graph_type === BAR_STACKED ||
        graph_type === BAR_STACKED_EQUAL_HEIGHT ||
        graph_type === LINE
      ) {
        return formatCitySpecificDataForLine(d, isLineGraph);
      } else return formatCitySpecificData(d, graph_type, isLineGraph);
    }
    if (report_type == REPORT_TYPES.citywisenew) {
      if (
        graph_type === BAR_STACKED ||
        graph_type === BAR_STACKED_EQUAL_HEIGHT ||
        graph_type === LINE
      ) {
        return formatNewCitySpecificDataForLine(d, isLineGraph);
      } else return formatNewCitySpecificData(d, graph_type, isLineGraph);
    }
    if (report_type == REPORT_TYPES.TagBasedTagAnalysis) {
      if (graph_type === BAR_STACKED_EQUAL_HEIGHT) {
        return formatTagAnalysisData(d);
      }
    }
    if (report_type == REPORT_TYPES.EntityBasedTagAnalysis) {
      if (graph_type === BAR_STACKED_EQUAL_HEIGHT) {
        return formatTagAnalysisDataByEntity(d);
      }
    }
    try {
      const list = d.graph_data
        .map(
          (gd) =>
            gd &&
            gd.post_count
              .map((pc) => ({ ...pc, topic_name: gd.topic_name }))
              .flat()
        )
        .flat();
      const groupByEntity = groupBy(list, "topic_name");
      const entityList = Object.keys(groupByEntity);
      const groupedDataByDate = (report_type == REPORT_TYPES.TopPostersTrend || report_type == REPORT_TYPES.InfluencerWithDetail)?groupBy(list, "created"):groupBy(list, "created_at");
      const labels = Object.keys(groupedDataByDate).sort();
      let formattedLabel = labels.map((d) => getTrendGraphDateFormat(d));
      if (isLineGraph) {
        formattedLabel = getLineGraphFormat(formattedLabel, true);
      }
      if (report_type === REPORT_TYPES.TopLanguages) {
        const labels = new Set();
        const data = [];
        const countData = [];
        let hcData = [];
        let totalCount = 0;
        d.graph_data.forEach(({ post_count }) => {
          post_count.forEach(({ lang, count }) => {
            if (
              lang &&
              typeof lang != "undefined" &&
              lang != "null" &&
              lang != "und" &&
              LANGUAGE_CODES[lang]
            ) {
              labels.add(lang);
              totalCount += parseInt(count);
              data.push({ label: lang, count: count });
            }
          });
        });
        Array.from(labels).forEach((label) => {
          let count = 0;
          data.forEach((d) => {
            if (d.label == label) {
              count += parseInt(d.count);
            }
          });
          hcData.push([LANGUAGE_CODES[label], count]);
          countData.push(count);
        });
        const color = getRandomUniqueColor(data.length);
        return {
          hcData,
          datasets: [
            {
              data: countData,
              backgroundColor: color,
              label: "Top Languages",
              borderColor: color,
              borderWidth: 0,
              barThickness: "flex",
              fill: "start",
              lineTension: 0,
            },
          ],
          labels: Array.from(labels).map((l) => LANGUAGE_CODES[l]), //Array.from(labels).map((l) => LANGUAGE_CODES[l])
        };
      }
      if (selectedInlineGraphType === PIE) {
        const data =
          entityList.map((ent) => {
            let postCount = 0;
            groupByEntity[ent].forEach((el) => {
              postCount += Number(el.count);
            });
            return postCount;
          }) || [];
        return {
          datasets: [
            {
              data,
              backgroundColor: getRandomUniqueColor(data.length),
              label: "Share of voice",
            },
          ],
          labels: entityList,
        };
      } else if (selectedInlineGraphType === GENDER) {
        return {
          mValue: 40,
          fValue: 60,
        };
      } else {
        const graphColors = getRandomUniqueColor(entityList.length);
        const datasets = entityList.map((entry, index) => {
          let data = labels.map((elm) => {
            const dateObject = groupedDataByDate[elm];
            const currentElmArticleCount =
              dateObject && dateObject.filter((e) => e.topic_name === entry)[0];
            return (
              (currentElmArticleCount && currentElmArticleCount.count) || 0
            );
          });
          data = isLineGraph ? getLineGraphFormat(data) : data;
          return {
            data,
            label: entry,
            backgroundColor:
              selectedInlineGraphType === AREA &&
              typeof window.Color === "function"
                ? window.Color(graphColors[index]).alpha(0.5).rgbString()
                : graphColors[index],
            borderColor: graphColors[index],
            borderWidth: 1,
            barThickness: "flex",
            fill: selectedInlineGraphType === AREA ? "start" : false,
            lineTension: 0,
          };
        });
        return {
          labels: formattedLabel,
          datasets,
        };
      }
    } catch (e) {
      console.log("Error in social widget creation", e);
      return {
        labels: [],
        datasets: [],
      };
    }
  }

  function formatDataByMediaExposure(d = []) {
    try {
      const {
        graphDataType: { print, online },
      } = reportType;
      const rType = type === V_PRINT ? print : online;
      const dataByReportType = d[rType] && d[rType].returnData;
      return dataByReportType;
    } catch (e) {
      return [];
    }
  }

  function formatedData(d = []) {
    if (!reportType) {
      return d;
    }
    if (
      reportType.reportCategory === "journalist" ||
      reportType.reportCategory === "edition"
    ) {
      return formatedDataByJournalist(
        d,
        selectedInlineGraphType,
        isLineGraph,
        type,
        report_type,
        isEmbededWidget
      );
    }
    if (reportType.reportCategory === "entitytag") {
      return formatThematicAnalysisEntity(
        d,
        selectedInlineGraphType,
        isLineGraph,
        type,
        report_type
      );
    }
    if (reportType.reportCategory === "tagentity") {
      return formatThematicAnalysisTag(
        d,
        selectedInlineGraphType,
        isLineGraph,
        type,
        report_type
      );
    }
    if (reportType.reportCategory === "sov") {
      return formatDataBySOV(
        d,
        selectedInlineGraphType,
        isLineGraph,
        type,
        report_type
      );
    }
    if (reportType.reportCategory === "tonality") {
      return formatDataByTonality(
        d,
        selectedInlineGraphType,
        isLineGraph,
        type,
        report_type
      );
    }
    if (reportType.reportCategory === "stateTrend") {
      return formatDataByTonality(
        d,
        selectedInlineGraphType,
        isLineGraph,
        type,
        report_type
      );
    }

    if (reportType.reportCategory === "publication") {
      return formatDataByPublication(
        d,
        selectedInlineGraphType,
        isLineGraph,
        type,
        report_type
      );
    }
    if (reportType.reportCategory === "city") {
      return formatDataByCity(
        d,
        selectedInlineGraphType,
        isLineGraph,
        type,
        report_type,
        selectedEdition,
        editionList
      );
    }
    if (reportType.reportCategory === "state") {
      return formatDataByCity(
        d,
        selectedInlineGraphType,
        isLineGraph,
        type,
        report_type,
        selectedEdition,
        editionList
      );
    }
    if (reportType.reportCategory === "mediaexposure") {
      return formatDataByMediaExposure(d);
    }
    if (reportType.reportCategory === "keyword") {
      return formatWordCloudData(d);
    }
    if (reportType.reportCategory === "language") {
      return formatDataByLanguage(
        d,
        selectedInlineGraphType,
        isLineGraph,
        type,
        report_type
      );
    }

    return formatDataByRanking(
      d,
      selectedInlineGraphType,
      isLineGraph,
      type,
      report_type
    );
  }

  function getWCTextPos(imgPos) {
    let textOffset = 0;
    if (isSameDateReport) {
      textOffset = isEmbededWidget ? 50 : 70;
    } else {
      textOffset = isEmbededWidget ? 110 : 90;
    }
    return imgPos - textOffset;
  }

  function svgDownload() {
    try {
      const uniqueIdentifier = isEmbededWidget
        ? `embedded-${identifier}`
        : identifier;
      const svg = document
        .getElementById(uniqueIdentifier)
        .querySelector("svg");
      if (svg) {
        const canvas = document.createElement("canvas");
        const width = svg ? svg.width.animVal.value : 600;
        const height = svg ? svg.height.animVal.value + 200 : 600;
        canvas.width = width;
        canvas.height = height;
        let logoLoaded = false;
        const ctx = canvas.getContext("2d");
        const data = new XMLSerializer().serializeToString(svg);
        const DOM_URL = window.URL || window.webkitURL;
        const img = new Image();
        const biuLogoImg = new Image();
        biuLogoImg.src = biuLogo;
        biuLogoImg.onload = () => {
          logoLoaded = true;
          console.log(" logo loaded:");
        };
        const svgBlob = new Blob([data], {
          type: "image/svg+xml;charset=utf-8",
        });
        const url = DOM_URL.createObjectURL(svgBlob);
        const imagePostion = canvas.width / 2 - 25;
        const textPosition = getWCTextPos(imagePostion);
        img.onload = function () {
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 100);
          ctx.drawImage(biuLogoImg, imagePostion, 5, 50, 50);
          ctx.stroke();
          ctx.font = "12px Arial";
          ctx.strokeText(getTimelineText(), textPosition, 70);
          ctx.textAlign = "center";
          ctx.strokeText(getInlineFilterText(), canvas.width / 2, 90);
          ctx.textAlign = "center";
          var imgURI = canvas.toDataURL("image/png");
          const a = document.createElement("a");
          a.href = imgURI;
          a.download = `${chartTitle}.png`;
          a.click();
        };
        img.src = url;
      }
    } catch (e) {
      throw ("SVG Download failed", e);
    }
  }

  function formatCSVData(inputData,tReport) {
    let fieldsToDelete = [
      "entity_id",
      "source_id",
      "entity_group",
      "client_id",
      "laguage_id",
      "topic_id",
      "topic_category",
      "publication_id",
      "mavcntkh",
      "ccmcntlkh",
      "Not Rated",
    ];
    const fieldsToReplace = {
      articlecnt: "Count",
      entity: "Company",
      publish_date: "Publish Date",
      source_name: "Journalist",
      language_name: "Language",
      percentage: "Percentage",
      topic_name: "Company",
      post_count: "Count",
      keyword: "Keyword",
      online_cnt: "Count",
      print_cnt: "Count",
      publication_name: "Publication",
      from_username: "Name",
      count: "Count",
      share_count: "Share Count",
      comment_count: "Comment Count",
      like_count: "Like Count",
      followers_count: "Followers",
      reach_count: "Reach",
      wordcountsum: "Word Count",
      ccmcnt: "CCM Count",
      mavcnt: "MAV Count",
      ccm: "CCM Count",
      mav: "MAV Count",
      ccmsum: "CCM",
      mavsumlkh: "MAV",
      channel_type: "Platform",
      created_at: "Publish Date",
      tonality: "Sentiment",
      Informative: "Neutral",
    };
    if (widget.graph_type === CHOROPLETH) {
      try {
        const gd = groupBy(inputData, "country");
        inputData = Object.keys(gd).map((country) => {
          return {
            Country: country,
            Count: gd[country].length,
          };
        });
      } catch {
        return;
      }
    }
    if (
      widget.graph_type === WORD_CLOUD &&
      (widget.type === V_PRINT || widget.type === V_ONLINE)
    ) {
      fieldsToDelete.push(widget.type === V_PRINT ? "online_cnt" : "print_cnt");
    }
    const fieldsToReplaceKeys = Object.keys(fieldsToReplace);
    if (Array.isArray(inputData)) {
      const dataKeys = Object.keys(inputData[0]);
      if (
        dataKeys.indexOf("post_count") !== -1 ||
        dataKeys.indexOf("data") !== -1
      ) {
        const sortKey = (dataKeys.indexOf("post_count") !== -1 ? "post_count":(dataKeys.indexOf("post_data") !== -1 ? "post_data" : "data"));
        inputData = inputData.sort((a, b) => {
          return b[sortKey].length - a[sortKey].length;
        });
      }
    }

    return inputData.map((ele) => {
      fieldsToDelete.forEach((fd) => delete ele[fd]);
      const eleKeys = Object.keys(ele);
      const obj = {};
      console.log(eleKeys,"eleKeys")
      eleKeys.forEach((eleKey) => {
        if (
          ("post_count" === eleKey && typeof ele[eleKey] === "object") ||
          ("post_data" === eleKey && typeof ele[eleKey] === "object") ||
          ("data" === eleKey && typeof ele[eleKey] === "object")
        ) {
          ele[eleKey].forEach((tc) => {
            if (
              tc.tonality ||
              tc.created_at ||
              tc.keyword ||
              tc.city ||
              tc.channel_type ||
              tc.lang
            ) {
              let channelType = "";
              if (tc.channel_type && tReport !== REPORT_TYPES.citywisenew) {
                const pId = SOCIAL_SOURCES_OPTIONS.find(
                  (e) => e.value == tc.channel_type
                );
                channelType = pId ? pId.label : "";
              }
            if(tReport !== REPORT_TYPES.citywisenew){
                obj[
                  tc.tonality ||
                    tc.keyword ||
                    tc.city ||
                    channelType ||
                    tc.lang ||
                    moment(tc.created_at).format("DD-MM-YYYY")
                ] = tc.count || 0;
              }
              else if(tc.city !== null){
                obj[
                    tc.city
                ] = tc.count || 0;
              }
            }
          });
          return;
        }
        if (fieldsToReplaceKeys.indexOf(eleKey) !== -1) {
          if (eleKey === "publish_date" || eleKey === "created_at") {
            obj[fieldsToReplace[eleKey]] = moment(ele[eleKey]).format(
              "DD-MM-YYYY"
            );
          } else if (eleKey === "channel_type") {
            const pId = SOCIAL_SOURCES_OPTIONS.find(
              (e) => e.value == ele[eleKey]
            );
            obj[fieldsToReplace[eleKey]] = pId ? pId.label : "NA";
          } else {
            obj[fieldsToReplace[eleKey]] = ele[eleKey];
          }
        } else {
          obj[eleKey] = ele[eleKey];
        }
      });
      console.log(obj,"obj")
      return obj;
    });
  }

  function getDateDiff(toDate, fromDate) {
    const t = moment(toDate, "MM-DD-YYYY");
    const f = moment(fromDate, "MM-DD-YYYY");
    const diff = t.diff(f, "days");
    return diff;
  }

  function downloadCsv(fName) {
    try {
      if (
        (!dataByReportType.length &&
          !(
            rawDataApiResponse &&
            rawDataApiResponse.graph_data &&
            rawDataApiResponse.graph_data.length
          ) &&
          (!worldMapData || !worldMapData.length)) ||
        showError
      ) {
        // no data
        return;
      }
      let dt = dataByReportType.length
        ? dataByReportType
        : worldMapData.length
        ? worldMapData
        : rawDataApiResponse.graph_data;

      if (
        widget.graph_type === TABLE &&
        graphApiResponse &&
        graphApiResponse.length
      ) {
        dt = graphApiResponse;
      }
      if (widget.report_type === REPORT_TYPES.PLATFORM_TONALITY) {
        dt = dt
          .map((et) =>
            et.post_count
              .map((pc) => ({
                topic_name: et.topic_name,
                channel_type: pc.channel_type,
                tonality: pc.tonality,
                count: pc.count,
              }))
              .flat()
          )
          .flat();
      }
      // if (widget.report_type === REPORT_TYPES.ShareRetweet) {
      //   dt = dt
      //     .map((et) =>
      //       et.post_data
      //         .map((pc) => ({
      //           topic_name: et.topic_name,
      //           channel_type: pc.channel_type,
      //           tonality: pc.tonality,
      //           count: pc.share_count,
      //         }))
      //         .flat()
      //     )
      //     .flat();
      // }
      if (widget.report_type === REPORT_TYPES.PLATFORM_TREND) {
        dt = dt
          .map((et) =>
            et.post_data
              .map((pc) =>
                pc.data.map((dt) => ({
                  topic_name: et.topic_name,
                  channel_type: pc.channel_type,
                  created_at: dt.created_at,
                  count: dt.count,
                }))
              )
              .flat()
          )
          .flat();
      }
      if (widget.report_type === REPORT_TYPES.InfluencerWithDetail || widget.report_type === REPORT_TYPES.TopPostersTrend) {
        console.log(dt,"asdf")
        dt = dt
          .map((et) =>
            et.post_count
              .map((pt) => ({
                // pc.data.map((dt) => ({
                  topic_name: et.topic_name,
                  channel_type: pt.channel_type,
                  created_at: pt.created,
                  count: pt.count,
                // }))
              }))
              .flat()
          )
          .flat();
      }
      if (widget.report_type === REPORT_TYPES.ShareRetweet) {
        dt = dt
          .map((et) =>
            et.post_data
              .map((pc) =>({
                // pc.data.map((dt) => ({
                  topic_name: et.topic_name,
                  channel_type: pc.channel_type,
                  // created_at: pc.created_at,
                  share_count: pc.share_count,
                // }))
              }))
              .flat()
          )
          .flat();
      }
      if (widget.report_type === REPORT_TYPES.ReplyComment) {
        dt = dt
          .map((et) =>
            et.post_data
              .map((pc) =>({
                // pc.data.map((dt) => ({
                  topic_name: et.topic_name,
                  channel_type: pc.channel_type,
                  // created_at: pc.created_at,
                  comment_count: pc.comment_count,
                // }))
              }))
              .flat()
          )
          .flat();
      }
      if (widget.report_type === REPORT_TYPES.Attachment) {
        dt = dt
          .map((et) =>
            et.post_data
              .map((pc) =>({
                // pc.data.map((dt) => ({
                  topic_name: et.topic_name,
                  channel_type: pc.channel_type,
                  // created_at: pc.created_at,
                  count: pc.count,
                // }))
              }))
              .flat()
          )
          .flat();
      }
      if (widget.report_type === REPORT_TYPES.Like) {
        dt = dt
          .map((et) =>
            et.post_data
              .map((pc) =>({
                // pc.data.map((dt) => ({
                  topic_name: et.topic_name,
                  channel_type: pc.channel_type,
                  // created_at: pc.created_at,
                  like_count: pc.like_count,
                // }))
              }))
              .flat()
          )
          .flat();
      }
      // if (widget.report_type === REPORT_TYPES.AuthorLike) {
      //   dt = dt
      //     .map((et) =>
      //       et.post_data
      //         .map((pc) =>({
      //           // pc.data.map((dt) => ({
      //             topic_name: et.topic_name,
      //             channel_type: pc.channel_type,
      //             // created_at: pc.created_at,
      //             like_count: pc.likes_count,
      //           // }))
      //         }))
      //         .flat()
      //     )
      //     .flat();
      // }
      if (widget.report_type === REPORT_TYPES.MemberType) {
        dt = dt
          .map((et) =>
            et.post_data
              .map((pc) =>({
                // pc.data.map((dt) => ({
                  topic_name: et.topic_name,
                  channel_type: pc.channel_type,
                  // created_at: pc.created_at,
                  count: pc.count,
                // }))
              }))
              .flat()
          )
          .flat();
      }
      // if (widget.report_type === REPORT_TYPES.AuthorCreated) {
      //   dt = dt
      //     .map((et) =>
      //       et.post_data
      //         .map((pc) =>({
      //           // pc.data.map((dt) => ({
      //             topic_name: et.topic_name,
      //             channel_type: pc.channel_type,
      //             // created_at: pc.created_at,
      //             count: pc.count,
      //           // }))
      //         }))
      //         .flat()
      //     )
      //     .flat();
      // }
      if (widget.report_type === REPORT_TYPES.TypeOfPost) {
        dt = dt
          .map((et) =>
            et.post_data
              .map((pc) =>({
                // pc.data.map((dt) => ({
                  topic_name: et.topic_name,
                  channel_type: pc.channel_type,
                  // created_at: pc.created_at,
                  count: pc.count,
                // }))
              }))
              .flat()
          )
          .flat();
      }

      // To remove unwanted fields from report CSV.
      dt = dt.map((d) => {
        PRINT_ONLINE_COUNT_KEYS.forEach((pk) => {
          if (pk !== reportType.countKey) {
            delete d[pk];
          }
        });
        return d;
      });

      const csvData = formatCSVData(dt,widget.report_type);
      let fields = [];
      csvData.forEach((cd) => {
        fields = [...fields, ...Object.keys(cd)].filter(onlyUnique);
      });
      const FROM_DATE = moment(from_date).format("DD-MM-YYYY");
      const TO_DATE = moment(to_date).format("DD-MM-YYYY");
      const diffInDays = getDateDiff(to_date, from_date);
      let csvContent = "";
      if (reportType && reportType.label) {
        csvContent = `,,Report - ${reportType.label} \n`;
      }
      if (selectedInlineJournalist && !!selectedInlineJournalist.label) {
        csvContent += `,,Journalist - ${selectedInlineJournalist.label} \n`;
      }
      if (selectedInlinePlatform && selectedInlinePlatform.label) {
        csvContent += `,,Platform - ${selectedInlinePlatform.label} \n`;
      }
      if (selectedInlinePublication && selectedInlinePublication.label) {
        csvContent += `,,Publication - ${selectedInlinePublication.label} \n`;
      }
      if (selectedInlineSentiment && selectedInlineSentiment.label) {
        csvContent += `,,Sentiment - ${selectedInlineSentiment.label} \n`;
      }
      if (selectedEdition && selectedEdition.label) {
        csvContent += `,,Edition - ${selectedEdition.label} \n`;
      }
      csvContent += `,,Report for the duration ${
        diffInDays > 0 ? FROM_DATE + " to " + TO_DATE : FROM_DATE
      } \n\n\n`;

      csvContent += fields.join(",") + "\n";

      csvData.forEach((ele) => {
        let eleFields = fields.map((fieldEle) => {
          return ele[fieldEle] || "0";
        });
        csvContent += eleFields.join(",") + "\n";
      });
      const a = document.createElement("a");
      // replace is to get rid of # breaking the CSV
      const encodedContent = encodeURI(csvContent).replaceAll("#", "%23");
      a.href = `data:text/csv;charset=utf-8,\uFEFF${encodedContent}`;
      a.download = `${fName}.csv`;
      a.click();
    } catch (e){
      console.log("Error while downloading csv",e);
    }
  }

  function downloadChart(fName) {
    try {
      if (reportType.id == REPORT_TYPES.TotalMediaExposure) {
        const doc = new jsPDF();
        doc.autoTable({ html: `#${identifier}` });
        doc.save(fName);
        return;
      }
      if (
        reportType.id == REPORT_TYPES.KeywordCloudNOA ||
        reportType.id == REPORT_TYPES.WorldMap
      ) {
        svgDownload();
        return;
      }
      graphRef.current.chart.exportChart();
    } catch (e) {
      alert("Failed to download chart");
      console.error(e);
    }
  }
  const resolveSentiment = (tone) => {
    const tempTone = TONALITY_FILTER.values.filter((t) => t.id == tone);
    if (tempTone && tempTone[0]) {
      return tempTone[0].text;
    }
    return null;
  };

  function gotoWidgetDetails({
    edition,
    sourceName,
    date,
    entityId,
    tagFilterName,
    publication,
    tonality,
    language,
    keyword,
    country,
    countryFeeds,
    city,
    channelType,
    from_username,
    ent,
    categoryId,
  } = {}) {
    let defaultData = { ...widget };
    if (selectedMainPressRelease) {
      defaultData.press_release = selectedMainPressRelease;
    }
    if (ent) {
      defaultData.ent = ent;
    }
    if (date) {
      defaultData.to_date = date;
      defaultData.from_date = date;
    }
    if (publication || selectedMainPublication || selectedInlinePublication) {
      let tempPublication = {
        id: undefined,
        text: undefined,
      };

      if (publication && publication.publication_id) {
        tempPublication = {
          id: publication.publication_id,
          text: publication.publication_id,
        };
      }
      if (selectedInlinePublication && selectedInlinePublication.value) {
        tempPublication = {
          id: selectedInlinePublication.value,
          text: selectedInlinePublication.label,
        };
      }
      if (selectedMainPublication && selectedMainPublication.length) {
        tempPublication = selectedMainPublication;
      }
      if (tempPublication) {
        defaultData.publication = tempPublication;
      }
    }
    if(report_type == REPORT_TYPES.StateWiseTonality || report_type == REPORT_TYPES.StateWiseTrend){
      defaultData.state = selectedState?.value;  
    }
    defaultData.edition = getCorrectEdition();
    if (
      report_type == REPORT_TYPES.MediaWiseNOARanking ||
      report_type == REPORT_TYPES.EditionWiseNOATrend
    ) {
      defaultData.edition = [edition.id];
    }

    if (
      report_type == REPORT_TYPES.ThematicAnalysisTag ||
      report_type == REPORT_TYPES.ThematicAnalysisEntity
    ) {
      defaultData.category = categoryId;
    }
    if (tonality) {
      defaultData.tonality = tonality;
    }
    else if(report_type === REPORT_TYPES.StateWiseTrend){
      defaultData.tonality =
            selectedInlineSentiment && selectedInlineSentiment.text
              ? selectedInlineSentiment.text
              : CONSTANTS.TONALITY.map(({ text }) => text);
    }
    if (
      isAnalysisReport &&
      selectedMainSentiment &&
      report_type != REPORT_TYPES.SOVTonality &&
      report_type != REPORT_TYPES.PLATFORM_TONALITY &&
      report_type != REPORT_TYPES.PublicationTonalityNOARanking &&
      report_type != REPORT_TYPES.JournalistTonalityNOARanking &&
      report_type != REPORT_TYPES.CityWiseTonality &&
      report_type != REPORT_TYPES.StateWiseTonality
    ) {

      if (isPrintAndOnline) {
        if (report_type === REPORT_TYPES.TonalityWordCount) {
          defaultData.tonality = tonality;
        } else if (report_type === REPORT_TYPES.TonalityNAOTrend ) {
          defaultData.tonality =
            selectedInlineSentiment && selectedInlineSentiment.text
              ? selectedInlineSentiment.text
              : CONSTANTS.TONALITY.map(({ text }) => text);
        } else {
          defaultData.tonality = selectedMainSentiment.map((elm) =>
            resolveSentiment(elm)
          );
        }
      } else {
        defaultData.tonality = selectedMainSentiment;
      }
    }

    if (sourceName || selectedInlineJournalist) {
      defaultData.reporter = sourceName || selectedInlineJournalist.label;
      defaultData.reporterId =
        selectedInlineJournalist && selectedInlineJournalist.value;
    }

    if (
      report_type == JournalistAnalysisPrint ||
      report_type == EditionWiseNOATrend
    ) {
      defaultData.ottChannel =
        selectedInlineJournalist && selectedInlineJournalist.label;
    }

    if (language && language.length) {
      defaultData.language = language;
    }
    if (entityId) {
      defaultData.entityId = [entityId.toString()];
      defaultData.topic_ids = [entityId.toString()];
    }
    const tempSourceId = getCorrectSourceId();
    if (
      (report_type == JournalistAnalysisPrint ||
        report_type == EditionWiseNOATrend) &&
      tempSourceId &&
      tempSourceId.length
    ) {
      defaultData.entityId = tempSourceId;
      defaultData.topic_ids = tempSourceId;
    }
    if (tagFilterName) {
      defaultData.filterTags = [tagFilterName];
    }
    if (keyword && keyword.length) {
      defaultData.keywords = keyword;
    }
    if (country && countryFeeds) {
      defaultData.worldMapData = {
        countryFeeds,
        country,
      };
    }
    if (city) {
      defaultData.city = city;
    }
    defaultData.channel_type = getCorrectChannelType(channelType);

    if (from_username) {
      defaultData.from_username = from_username;
    }

    if (isAnalysisReport && selectedMainCountry) {
      defaultData.country = selectedMainCountry;
    }

    const correctEntityList = entityListByType;
    const clickedEntity =
      correctEntityList &&
      correctEntityList.filter((e) => {
        if (e && e.id && e.id == entityId) {
          return e.entity_name || e.name;
        }
      });

    defaultData.useMutipleTopicsApi =
      (report_type == REPORT_TYPES.KeywordCloudNOA ||
        report_type == REPORT_TYPES.TopLanguages) &&
      !isPrintAndOnline;
    defaultData.selectedInlineWCType = selectedInlineWCType;
    const lang = dataByReportType.find((elm) => elm.laguage_id == language);
    const clickedLanguage =
      type == V_ONLINE || type == V_PRINT
        ? (lang && lang.language_name) || ""
        : language;
    // Since, such reports are queried by clicked language and the entities == the entities contributed to the widget.
    defaultData.clickedEntityName =
      country ||
      keyword ||
      clickedLanguage ||
      (Array.isArray(clickedEntity) &&
        clickedEntity[0] &&
        (clickedEntity[0].entity_name || clickedEntity[0].name));

    if (!isEmbededWidget) {
      setFeedsParams(defaultData);
      setShowFeedsList(true);
    }
    if (isEmbededWidget && setEmbededFeedsParams) {
      setEmbededFeedsParams(defaultData);
    }
  }

  function onEntityClick(e, routeParams) {
    setCountType(routeParams.labels);
    try {
      gotoWidgetDetails(routeParams);
    } catch (err) {
      console.error("Error in contributed feeds : ", err);
      return;
    }
  }

  function formatWordCloudData(d) {
    try {
      const {
        graphDataType: { print, online },
      } = reportType;
      let countKey = "online_cnt";
      let rType = online;
      if (type == V_PRINT) {
        countKey = "print_cnt";
        rType = print;
      }
      const isBothMediatype = type == V_PRINT_AND_ONLINE;
      const dataByReportType = d[rType] && d[rType].returnData;
      const data = dataByReportType.map((el) => {
        const val = isBothMediatype
          ? parseInt(el["print_cnt"], 10) + parseInt(el["online_cnt"], 10)
          : parseInt(el[countKey], 10);
        return {
          name: el.keyword,
          weight: val,
        };
      });
      return data.filter((elm) => elm.weight);
    } catch (e) {
      return {
        name: "",
        weight: 0,
      };
    }
  }

  function onCancelDeleteWidget() {
    setDeleteId("");
    setShowDeleteConfirm(false);
  }

  function onWidgetDelete(id) {
    if (!id) {
      return;
    }
    setDeleteId(id);
    setShowDeleteConfirm(true);
  }

  function deleteWidget() {
    if (!deleteId) {
      return;
    }
    if (deleteId === WIDGET_TYPES.FEED_WIDGET) {
      handleTodayFeedWidgeStatus(false);
      return;
    }
    httpDelete(`${unifiedEnvConfig.WIDGET}/${deleteId}?client_id=${clientId}`)
      .then(({ status, message }) => {
        if (status === DELETED) {
          const filteredWidgetsData = filteredWidgets.filter(
            (wd) => wd.id !== deleteId
          );
          const widgetsData = widgets.filter((wd) => wd.id !== deleteId);
          setFilteredWidgets(filteredWidgetsData);
          setWidgets(widgetsData);
        } else {
          alert(message || "Error while deleting Widget");
        }
      })
      .catch(() => {
        alert("Error while deleting Widget");
      })
      .finally(() => {
        setDeleteId("");
        setShowDeleteConfirm(false);
      });
  }
  function renderInlineGraphTypeSwitch() {
    if (inlineGraphTypeOptions && inlineGraphTypeOptions.length) {
      let inlineOpts;
      if (report_type == REPORT_TYPES.TopPostersWithDetail) {
        inlineOpts = [...inlineGraphTypeOptions];
      }
      else if (report_type == REPORT_TYPES.TopPostersTrend) {
        inlineOpts = [...inlineGraphTypeOptions];
      } else {
        inlineOpts = [...inlineGraphTypeOptions].filter(
          (igtOpts) => igtOpts.value !== TABLE && igtOpts
        );
      }
      return inlineOpts.map((gType) => {
        const isChecked = selectedInlineGraphType
          ? selectedInlineGraphType == gType.value
          : graph_type == gType.value;

        return (
          <React.Fragment key={`${isChecked}${gType.value}`}>
            <Dropdown.Item className="diWithRadio">
              <label
                className="inputWrap"
                onClick={() => setSelectedInlineGraphType(gType.value)}
              >
                {gType.label}
                <input type="radio" checked={isChecked} />
                <span className="checkmark"></span>
              </label>
            </Dropdown.Item>
          </React.Fragment>
        );
      });
    }
    return null;
  }

  const getCorrectTittle = (type, report) => {
    if (type === V_PRINT && report === "PublicationNOARanking") {
      return "Top Publications (Articles)";
    } else if (type === V_PRINT && report === "PublicationNOATrend") {
      return "Publications by Trend (Articles)";
    } else return reportType && reportType.label;
  };

  let chartTitle = getCorrectTittle(type, reportType.value);
  const showChartValueOption =
    !isEmbededWidget &&
    (selectedInlineGraphType
      ? selectedInlineGraphType == PIE || selectedInlineGraphType == DOUGHNUT
      : graph_type == PIE || graph_type == DOUGHNUT);
  let isValidWidget =
    graphApiResponse &&
    graphApiResponse.datasets &&
    !!graphApiResponse.datasets.length &&
    graphApiResponse.labels &&
    !!graphApiResponse.labels.length;
  isValidWidget =
    graph_type == CHOROPLETH && worldMapData ? true : isValidWidget;

  const customWidget = widget
    ? { ...widget, graph_type: selectedInlineGraphType }
    : {};
  return (
    <div className="chartsContainer" ref={chartContainer}>
      <div className="chartsWrapper">
        <div className="chartActionWrap">
          {showWidgetConfig && (
            <AddWidget
              setWidgetCreationStatus={setWidgetCreationStatus}
              editWidgetData={editWidgetData}
              selectedDashboard={selectedDashboard}
              showTodaysFeedWidget={showTodaysFeedWidget}
              handleTodayFeedWidgeStatus={handleTodayFeedWidgeStatus}
              fetchWidgets={fetchWidgets}
              setEditWidgetData={setEditWidgetData}
              showButton={false}
              showModal={showWidgetConfig}
            />
          )}
          <ConfirmModal
            show={showDeleteConfirm}
            onCancel={onCancelDeleteWidget}
            modalTitle="Delete Widget"
            confirmButtonText="Delete"
            confirmText="Are you sure you want to delete this Widget?"
            onConfirm={deleteWidget}
          />
          {showFeedsList && (
            <EmbededFeedsList
              feedsParams={feedsParams}
              onCancel={() => setShowFeedsList(false)}
              widget={customWidget}
              inlineGraphTypeOptions={inlineGraphTypeOptions}
              onWidgetDelete={onWidgetDelete}
              setWidgetCreationStatus={setWidgetCreationStatus}
              fetchWidgets={fetchWidgets}
              selectedDataType={
                showPercentage ? DATA_TYPES.PERCENTAGE : DATA_TYPES.NUMBER
              }
              isAnalysisReport={isAnalysisReport}
              selectedInlineEdition={selectedEdition}
              selectedInlineState={selectedState}
              selectedInlinePublication={selectedInlinePublication}
              selectedInlineInfluencerEntity={selectedInlineInfluencerEntity}
              selectedInlineWCEntity={selectedInlineWCEntity}
              twitterFeeds={twitterFeeds}
              insightFeeds={insightFeeds}
              selectedFilter={
                selectedFilter && selectedFilter.label
                  ? selectedFilter.label
                  : selectedFilter
              }
              tabData={tabData}
              topicId={topicId}
              countType={countType}
              tonalities={tonality}
              widgetApiInProgress={widgetApiInProgress}
              startRange={startRange}
              endRange={endRange}
              fromUserName={fromUserName}
              setFromUserName={setFromUserName}
            />
          )}
          <div className="chartActionLeft">
            <VerticalTag
              key={type}
              type={
                !twitterFeeds && (insightFeeds == 0 || insightFeeds == undefined)
                  ? name === "Influencers" || name === "Verified Authors"
                    ? TWITTER_INSIGHTS
                    : type
                  : (
                    insightFeeds != 0 && insightFeeds != undefined && insightFeeds == LINKEDIN?
                      LINKEDIN_INSIGHTS
                      :(
                        insightFeeds != 0 && insightFeeds != undefined && insightFeeds == FACEBOOK?
                          FACEBOOK_INSIGHTS
                          :(
                            insightFeeds != 0 && insightFeeds != undefined && insightFeeds == INSTAGRAM?
                              INSTAGRAM_INSIGHTS
                              :TWITTER_INSIGHTS)))
              }
            />
            {/* {REPORT_TYPES.INFLUENCERS !== report_type && REPORT_TYPES.AuthorTweetCount !== report_type && REPORT_TYPES.AuthorCreated !== report_type && REPORT_TYPES.AuthorFollowing !== report_type && REPORT_TYPES.AuthorLike !== report_type && REPORT_TYPES.AuthorListed !== report_type?
              <>
              {((selectedInlinePlatform && selectedInlinePlatform.value == FACEBOOK) || (!selectedInlinePlatform && channel_type && channel_type.includes(FACEBOOK))) && <FacebookIcon cla="ml-2" />}
              {((selectedInlinePlatform && selectedInlinePlatform.value == INSTAGRAM) || (!selectedInlinePlatform && channel_type && channel_type.includes(INSTAGRAM))) && <InstagramIcon cla="ml-2" />}
              {((selectedInlinePlatform && selectedInlinePlatform.value == TWITTER) || (!selectedInlinePlatform && channel_type && channel_type.includes(TWITTER))) && <TwitterIcon cla="ml-2" />}
              {((selectedInlinePlatform && selectedInlinePlatform.value == YOUTUBE) || (!selectedInlinePlatform && channel_type && channel_type.includes(YOUTUBE))) && <YoutubePlayIcon cla="ml-2" />}
              {((selectedInlinePlatform && selectedInlinePlatform.value == LINKEDIN) || (!selectedInlinePlatform && channel_type && channel_type.includes(LINKEDIN))) && <img
                src="https://backendportal.conceptbiu.com/assets/article_download/icons8-linkedin-30.png"
                alt="NA"
                className="ml-2"
                width={25}
                height={25}
                />}
                </>:<TwitterIcon cla="ml-2" />}

            {(type == V_SOCIAL && !twitterFeeds && !name === "Influencers") ||
              (!name === "Verified Authors" &&
                REPORT_WISE_SOCIAL_ICONS[report_type] && (
                  <SocialIcon type={REPORT_WISE_SOCIAL_ICONS[report_type]} />
                ))} */}
            <WidgetInlineFilters
              editionList={editionList}
              stateList={stateList}
              selectedEdition={selectedEdition}
              setSelectedEdition={setSelectedEdition}
              selectedState={selectedState}
              setSelectedState={setSelectedState}
              widget={widget}
              selectedInlinePublication={selectedInlinePublication}
              setSelectedInlinePublication={setSelectedInlinePublication}
              selectedInlineJournalist={selectedInlineJournalist}
              setSelectedInlineJournalist={setSelectedInlineJournalist}
              selectedInlineEntity={selectedInlineEntity}
              setSelectedInlineEntity={setSelectedInlineEntity}
              entityList={entityList}
              isAnalysisReport={isAnalysisReport}
              selectedClientId={clientId}
              selectedInlineWCType={selectedInlineWCType}
              setSelectedInlineWCType={setSelectedInlineWCType}
              setSelectedInlineSentiment={setSelectedInlineSentiment}
              selectedInlineSentiment={selectedInlineSentiment}
              selectedInlinePlatform={selectedInlinePlatform}
              setSelectedInlinePlatform={setSelectedInlinePlatform}
              reportCategory={reportType.reportCategory}
              setSelectedInlineWCEntity={setSelectedInlineWCEntity}
              selectedInlineWCEntity={selectedInlineWCEntity}
              setSelectedInlineInfluencerEntity={
                setSelectedInlineInfluencerEntity
              }
              selectedInlineInfluencerEntity={selectedInlineInfluencerEntity}
              setSelectedInlineAuthorFollowingEntity={
                setSelectedInlineAuthorFollowingEntity
              }
              selectedInlineAuthorFollowingEntity={selectedInlineAuthorFollowingEntity}
              setSelectedInlineAuthorTweetCountEntity={
                setSelectedInlineAuthorTweetCountEntity
              }
              selectedInlineAuthorTweetCountEntity={selectedInlineAuthorTweetCountEntity}
              setSelectedInlineAuthorListedEntity={
                setSelectedInlineAuthorListedEntity
              }
              selectedInlineAuthorListedEntity={selectedInlineAuthorListedEntity}
              setSelectedInlineAuthorLikeEntity={
                setSelectedInlineAuthorLikeEntity
              }
              selectedInlineAuthorLikeEntity={selectedInlineAuthorLikeEntity}
            />
            {renderAnalysisWidget()}
            {report_type === REPORT_TYPES.TopPostersTrend || report_type == REPORT_TYPES.InfluencerWithDetail?
              <div role="group" class="smallToggleBtnGroup btn-group">
                <button onClick={() => {setFromUserName("")}} style={{minWidth:'auto'}} className="tagBlue active btn btn-primary">
                  Reset
                </button>
              </div>:""}
          </div>
          <div className="chartActionRight">
            {(isEmbededWidget && isAnalysisReport) ||
            (report_type === REPORT_TYPES.INFLUENCERS || report_type === REPORT_TYPES.AuthorFollowing || report_type === REPORT_TYPES.AuthorTweetCount || report_type === REPORT_TYPES.AuthorListed || report_type === REPORT_TYPES.AuthorCreated  || report_type === REPORT_TYPES.AuthorLike) ? null : (
              <Dropdown className="chartActionBtn chartMoreIcon" alignRight>
                  <Dropdown.Toggle variant="default">
                    {<MoreIcon />}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {!isEmbededWidget && (
                      <>
                        <Dropdown.Header className="chartTypeHeading">
                          Chart Types
                        </Dropdown.Header>
                        {renderInlineGraphTypeSwitch()}
                      </>
                    )}
                    {showChartValueOption && (
                      <>
                        <Dropdown.Header className="chartValuesHeading">
                          Chart Values
                        </Dropdown.Header>
                        <Dropdown.Item className="diWithRadio numericItem">
                          <label
                            className="inputWrap"
                            onClick={() => setShowPercentage(false)}
                          >
                            Numeric
                            <input
                              type="radio"
                              key={showPercentage}
                              checked={!showPercentage}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Dropdown.Item>
                        <Dropdown.Item className="diWithRadio percentageItem">
                          <label
                            className="inputWrap"
                            onClick={() => setShowPercentage(true)}
                          >
                            Percentage
                            <input
                              type="radio"
                              key={showPercentage}
                              checked={showPercentage}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Dropdown.Item>
                      </>
                    )}
                    {!isAnalysisReport && (
                      <>
                        <Dropdown.Item
                          className="editItem"
                          onClick={(e) => {
                            e.stopPropagation();
                            setEditWidgetData && setEditWidgetData(widget);
                            setShowWidgetConfig && setShowWidgetConfig(true);
                          }}
                        >
                          Edit
                        </Dropdown.Item>
                        {onWidgetDelete &&
                        typeof onWidgetDelete === "function" ? (
                          <Dropdown.Item
                            className="removeItem redText"
                            onClick={(e) => {
                              e.stopPropagation();
                              onWidgetDelete(id);
                            }}
                          >
                            Remove
                          </Dropdown.Item>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </Dropdown.Menu>
              </Dropdown>
            )}
            <Dropdown className="chartActionBtn chartDownloadIcon" alignRight>
              <div className="hasTooltip">
                <Dropdown.Toggle variant="default">
                  <DownloadBlueIcon />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {selectedInlineGraphType != TABLE && (
                    <Dropdown.Item onClick={() => downloadChart(chartTitle)}>
                      Download PNG
                    </Dropdown.Item>
                  )}
                  {insightFeeds == 0 || insightFeeds == undefined?
                    <Dropdown.Item onClick={() => downloadCsv(chartTitle)}>
                      Download CSV
                    </Dropdown.Item>
                    :""}
                </Dropdown.Menu>
                <span className="tooltipWrap center">Download</span>
              </div>
            </Dropdown>
          </div>
        </div>
        {isLoading && <Loader />}
        {!twitterFeeds && insightFeeds == 0 && !isLoading && !showError && (
          <WidgetSwitch
            key={selectedInlineGraphType}
            graph_type={selectedInlineGraphType}
            graphApiResponse={graphApiResponse}
            chartTitle={chartTitle}
            onEntityClick={onEntityClick}
            report_type={report_type}
            entityList={entityListByType}
            editionList={editionList}
            showPercentage={showPercentage}
            dataByReportType={dataByReportType}
            identifier={identifier}
            worldMapData={worldMapData}
            isAnalysisReport={isAnalysisReport}
            selectedDataType={selectedDataType}
            isEmbededWidget={isEmbededWidget}
            countryWiseFeeds={countryWiseFeeds}
            channelType = {getCorrectChannelType()}
            type={type}
            setGraphRef={setGraphRef}
            setGraphRefList={setGraphRefList}
            fromUserName={fromUserName}
            setFromUserName = {(e) => {
              setFromUserName(e)
            }}
            to_date={to_date}
            from_date={from_date}
            dateHash={dateHash}
            widget={widget}
            selectedInlineJournalist={selectedInlineJournalist}
            selectedInlinePlatform={selectedInlinePlatform}
            selectedInlinePublication={selectedInlinePublication}
            selectedInlineSentiment={selectedInlineSentiment}
            isBlogAndForum={isBlogAndForum}
            isSocial={isSocial}
            selectedInlineWCType={selectedInlineWCType}
          />
        )}
        {twitterFeeds &&
          !isLoading &&
          tabData.length &&
          twitterBreakDownLine.length &&
          twitterBreakDownPie.length && (
            <WidgetSwitch
              key={selectedInlineGraphType}
              graph_type={selectedInlineGraphType}
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              onEntityClick={onEntityClick}
              report_type={report_type}
              entityList={entityListByType}
              editionList={editionList}
              showPercentage={showPercentage}
              dataByReportType={dataByReportType}
              identifier={identifier}
              worldMapData={worldMapData}
              isAnalysisReport={isAnalysisReport}
              selectedDataType={selectedDataType}
              isEmbededWidget={isEmbededWidget}
              countryWiseFeeds={countryWiseFeeds}
              type={type}
              setGraphRef={setGraphRef}
              setGraphRefList={setGraphRefList}
              twitterFeeds={twitterFeeds}
              twitterBreakDown={twitterBreakDown}
              twitterBreakDownPie={twitterBreakDownPie}
              twitterBreakDownLine={twitterBreakDownLine}
              selectedFilter={selectedFilter}
              twitterMetricsData={twitterMetricsData}
              keyMetrics={keyMetrics}
              reportType={reportType.reportCategory}
              channelType = {getCorrectChannelType()}
              to_date={to_date}
              from_date={from_date}
              dateHash={dateHash}
              widget={widget}
              selectedInlineJournalist={selectedInlineJournalist}
              selectedInlinePlatform={selectedInlinePlatform}
              selectedInlinePublication={selectedInlinePublication}
              selectedInlineSentiment={selectedInlineSentiment}
              isBlogAndForum={isBlogAndForum}
              isSocial={isSocial}
              selectedInlineWCType={selectedInlineWCType}
            />
          )}
        {(insightFeeds != undefined && insightFeeds != 0) &&
          !isLoading &&
          tabData.length &&
          twitterBreakDownLine.length &&
          twitterBreakDownPie.length && (
            <WidgetSwitch
              key={selectedInlineGraphType}
              graph_type={selectedInlineGraphType}
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              onEntityClick={onEntityClick}
              report_type={report_type}
              entityList={entityListByType}
              editionList={editionList}
              showPercentage={showPercentage}
              dataByReportType={dataByReportType}
              identifier={identifier}
              worldMapData={worldMapData}
              isAnalysisReport={isAnalysisReport}
              selectedDataType={selectedDataType}
              isEmbededWidget={isEmbededWidget}
              countryWiseFeeds={countryWiseFeeds}
              type={type}
              setGraphRef={setGraphRef}
              setGraphRefList={setGraphRefList}
              insightFeeds={insightFeeds}
              twitterBreakDown={twitterBreakDown}
              twitterBreakDownPie={twitterBreakDownPie}
              twitterBreakDownLine={twitterBreakDownLine}
              selectedFilter={selectedFilter}
              twitterMetricsData={twitterMetricsData}
              keyMetrics={keyMetrics}
              reportType={reportType.reportCategory}
              channelType = {getCorrectChannelType()}
              to_date={to_date}
              from_date={from_date}
              dateHash={dateHash}
              widget={widget}
              selectedInlineJournalist={selectedInlineJournalist}
              selectedInlinePlatform={selectedInlinePlatform}
              selectedInlinePublication={selectedInlinePublication}
              selectedInlineSentiment={selectedInlineSentiment}
              isBlogAndForum={isBlogAndForum}
              isSocial={isSocial}
              selectedInlineWCType={selectedInlineWCType}
            />
          )}
        {!twitterFeeds && (insightFeeds == 0 || insightFeeds == undefined) && !isLoading && showError && (
          <h6
            style={{
              textAlign: "center",
              marginTop: "25%",
            }}
          >
            {chartTitle}: No data available
          </h6>
        )}
        {twitterFeeds && !isLoading && !tabData.length && (
          <h6
            style={{
              textAlign: "center",
              marginTop: "25%",
            }}
          >
            {chartTitle}: No data available.
          </h6>
        )}
        {!twitterFeeds && (insightFeeds != 0 && insightFeeds != undefined) && !isLoading && !tabData.length && (
          <h6
            style={{
              textAlign: "center",
              marginTop: "25%",
            }}
          >
            {chartTitle}: No data available.
          </h6>
        )}
      </div>
    </div>
  );
};

Widget.defaultProps = {
  renderAnalysisWidget: () => {},
  contributedWidgetFilter: {},
};
